import React, { Component } from "react";
import { connect } from "react-redux";
import Sidebar from "../Sidebar/Sidebar";
import { InputTextarea } from "primereact/inputtextarea";
import { Accordion, AccordionTab } from "primereact/accordion";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { InputNumber } from "primereact/inputnumber";
import Footer_contact_tab from "../Footerpage/Footer_contact_tab";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import moment from "moment";
import axios from "axios";
import "./ManagementStatement.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { setUserSessionAuthKey, previewPdf } from "../../Component/commonUtils";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import Autocomplete from "react-autocomplete";
import { toHaveStyle } from "@testing-library/jest-dom/matchers";
import PreviewPdfHeader from "../../Component/PreviewPdf/previewPdfHeader";
import { Dialog } from "primereact/dialog";
import NoAccess from "../../Component/NoAccess/NoAccess";
import Editor from "../../Component/Editor/Editor";

let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
const mapStateToProps = (state) => {
  return {
    annualReportType: state.annualReportType.annualReportType.values,
    companyInformation: state.companyInformation.companyInformation.values,
    financialYear: state.financialYear.financialYear,
    incomeStatement: state.incomeStatement.incomeStatement,
    sessionDetails: state.sessionDetails,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    balanceSheet: state.balanceSheet.balanceSheet,
    notes: state.notes.notes,
    notesTemplateReqArrayReducer: state.notes.notesTemplateReqArrayReducer,
    managementStatus: state.managementStatus.managementStatus,
    readOnly: state.readOnly.readOnly,
    showWIPStatus: state.showWIPStatus.showWIPStatus
  };
};

let userSelectedLanguage = localStorage.getItem("selectedLanguage");
let tourGuidePages = localStorage.getItem("tourGuidePages");
let currentPageTourGuideName = "ManagementStatement";

let mgmtStmtTemplateReqArray = [],
  mgmtStmtTemplateResponse = {},
  columnNosArray = ["column2", "column3", "column4", "column5"],
  usedColumnNos = [],
  financialYearLoc = [],
  tabTitleArray = [],
  sideBarGreenTickPages = [],
  headerUpdateLineObj = {},
  currentReportGUIDFromUrl = "",
  autoDate = { from: "", to: "" },
  linkSharedUser,
  selectedCustOptions = [],
  custLineNo = 0,
  companyInfoFinancialYear = [],
  annualReportLinesResp = [],
  reportHeaderObj;

let steps = [
  // {
  //   content: TranslationFile.TourGuide_AddNewColumn_Btn[userSelectedLanguage],
  //   placement: "top",
  //   styles: {
  //     options: {
  //       width: 300,
  //     },
  //   },
  //   target: "#addNewColumnMS",
  //   title: TranslationFile.AddNewRecord[userSelectedLanguage],
  //   disableBeacon: true,
  //   delay: 500,
  // },
];
let headers = [],
  title,
  uniqueGroupNos,
  lineLevel8Rows,
  uniqueGroupNosForLineSum,
  groupedData,
  selectedMatrixHeaderObj,
  selectedMatrixLineObj,
  grouped,
  addIdx,
  selectedEditorObj,
  lastTextAreaText,
  lastTextAreaHeading,
  lastTextLineDetails;

class ManagementStatement extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.textAreaRef = React.createRef();
    this.state = {
      sideBarStatus: true,
      isLoading: true,
      mgmtStatementValue: "",
      activeIndex: [0],
      toggleOpen: false,
      companyInformation: "",
      companyName: "",
      currentFinancialYear: "",
      run: false,
      items: [],
      headerDetails: "",
      reRender: false,
      isToastVisible: false,
      pdfLoading: false,
      accessLevel: 0,
      addColumnLimitbutton: false,
      isPixel: window.innerWidth <= 1240
    };
  }
  handleChange(toggleOpen) {
    window.scroll(0, 0);
    if (toggleOpen == true) {
      let headerIdxList = [];
      Object.keys(tabTitleArray).map((heading, idx) => {
        headerIdxList.push(idx);
      });
      this.setState({ activeIndex: headerIdxList });
      this.setState({ toggleOpen: false });
    } else {
      let collapse = [];
      this.setState({ activeIndex: collapse });
      this.setState({ toggleOpen: true });
    }
  }

  openAll(resp) {
    let headerIdxList = [];
    Object.keys(resp).map((heading, idx) => {
      headerIdxList.push(idx);
    });
    let open = headerIdxList;
    this.setState({ activeIndex: open });
  }
  previewPdfLocal(currentReportGUIDFromUrl) {
    this.setState({ pdfLoading: true });
    setTimeout(() => {
      let pdfReturn = previewPdf(currentReportGUIDFromUrl);
      this.setState({ pdfLoading: !pdfReturn });
    }, 500);
  }
  checkForPreviousYear() {
    const { mgmtStatementValue, headerDetails } = this.state;
    if (
      headerDetails.previousYear1 == null ||
      headerDetails.previousYear1 == ""
    ) {
      let filteredMgmtValue = [];
      {
        Object.keys(mgmtStatementValue).map((heading, parentIdx) => {
          let responseArray = mgmtStatementValue[heading];
          responseArray = [...responseArray].sort(
            (a, b) => a.lineNo - b.lineNo
          );
          responseArray = responseArray.filter(
            (val) => val.financialYearValue == 0
          );
          filteredMgmtValue.push(responseArray);
        });
      }
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    let {
      companyInformation,
      sessionDetails,
      sideBarReducer,
      managementStatus
    } = this.props;
    localStorage.setItem("currentPageName", "Management Statement");

    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          let responseDate = response.data;
          reportHeaderObj = responseDate;
          this.setState({ headerDetails: responseDate });
          if (responseDate != "") {
            let reportAccessReq = {
              reportId: responseDate.reportID
            };
            axios
              .post(
                "/annualReport/getAccessStatus",
                reportAccessReq,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                switch (response.data) {
                  case 2:
                    linkSharedUser = 2; //Write
                    break;
                  case 3:
                    linkSharedUser = 3; //Read Only
                    break;
                  case 4:
                    linkSharedUser = 4; //No Access
                    break;
                }
                this.setState({
                  reRender: true,
                  accessLevel: linkSharedUser
                });
              })
              .catch((error) => {
                this.setState({
                  accessLevel: error.response.data
                });
              });
          }
          if (responseDate.companyName != "") {
            this.setState({
              companyName: responseDate.companyName
            });
          }

          if (responseDate.currentYear != "") {
            this.setState({
              currentFinancialYear: responseDate.currentYear
            });
            companyInfoFinancialYear.push(responseDate.currentYear);
          }

          if (responseDate.previousYear1 != "") {
            companyInfoFinancialYear.push(responseDate.previousYear1);
          }

          if (responseDate.previousYear2 != "") {
            companyInfoFinancialYear.push(responseDate.previousYear2);
          }

          if (responseDate.previousYear3 != "") {
            companyInfoFinancialYear.push(responseDate.previousYear3);
          }
        });

      let getJsonLines = {
        guid: currentReportGUIDFromUrl,
        pageName: "Management Statement"
      };

      let currentReportCompanyName = localStorage.getItem(
        "navigatedCompanyName"
      );
      if (currentReportCompanyName != "") {
        this.setState({
          companyInformation: currentReportCompanyName
        });
      }

      axios
        .post(
          "/annualReportLine/getLinesJson",
          getJsonLines,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          let responseData = response.data.managementStatement;
          if (responseData == undefined) {
            responseData = "";
          }

          if (responseData != "") {
            let jsonConvertedResponseData = JSON.parse(responseData);
            managementStatus.values = jsonConvertedResponseData;
            let financialYearFromJsonResponse = [];
            Object.keys(jsonConvertedResponseData).map((i, idx) => {
              if (i == "financialYearList") {
                financialYearFromJsonResponse = [
                  ...jsonConvertedResponseData[i]
                ];
              }
            });

            mgmtStmtTemplateReqArray = financialYearFromJsonResponse;

            delete jsonConvertedResponseData.financialYearList;

            tabTitleArray = jsonConvertedResponseData;
            this.openAll(jsonConvertedResponseData);

            axios
              .get(
                "/annualReport/getCompletedPages?reportId=" +
                  response.data.reportID,
                userSessionAuthKeyReturnValue
              )
              .then((completedStatementTypesResponse) => {
                sideBarReducer.values = completedStatementTypesResponse.data;
                sideBarGreenTickPages = completedStatementTypesResponse.data;
                this.setState({
                  reRender: true
                });
              });

            this.rowColPreparation(jsonConvertedResponseData);

            Object.keys(jsonConvertedResponseData).map((i, idx) => {
              if (idx == 1 || idx == 2) {
                let sortedRespArray = [...jsonConvertedResponseData[i]];
                let uniqueObjList = [];
                let seen = new Set();

                uniqueObjList = sortedRespArray.filter((item) => {
                  if (!seen.has(item.lineNo)) {
                    seen.add(item.lineNo);
                    return true;
                  }
                  return false;
                });
                jsonConvertedResponseData[i] = uniqueObjList;
              }
            });

            this.setState({
              mgmtStatementValue: jsonConvertedResponseData,
              isLoading: false
            });
            this.checkForPreviousYear();
          } else {
            mgmtStmtTemplateReqArray = [];

            if (companyInformation != undefined) {
              companyInformation != undefined &&
                companyInformation.financialYear.length &&
                companyInformation.financialYear.map((financialYear, idx) => {
                  let notesTemplateReq = {
                    validFromDate: moment(financialYear.from).format(
                      "YYYY-MM-DD"
                    ),
                    validToDate: moment(financialYear.to).format("YYYY-MM-DD"),
                    statementType: 2
                  };
                  mgmtStmtTemplateReqArray.push(notesTemplateReq);
                });

              axios
                .post(
                  "/user/getAnnualReportTemplateDetails",
                  mgmtStmtTemplateReqArray,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  if (Object.keys(response.data).length > 0) {
                    mgmtStmtTemplateResponse = response.data;
                    this.setState({
                      isLoading: false
                    });
                  } else {
                    this.setState({
                      isLoading: true
                    });
                  }

                  this.dataManipulation(mgmtStmtTemplateResponse, true, false);
                  tabTitleArray = mgmtStmtTemplateResponse;
                  this.openAll(mgmtStmtTemplateResponse);
                  this.rowColPreparation(mgmtStmtTemplateResponse);
                });
            } else {
              let getJsonLines = {
                guid: currentReportGUIDFromUrl,
                pageName: "Company Information"
              };

              axios
                .post(
                  "/annualReportLine/getLinesJson",
                  getJsonLines,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {
                  let responseData = response.data.companyInformation;

                  if (responseData == undefined) {
                    responseData = "";
                  }

                  if (responseData != "") {
                    let jsonConvertedResponseData = JSON.parse(responseData);
                    companyInformation = jsonConvertedResponseData.values;

                    managementStatus.values = jsonConvertedResponseData;

                    jsonConvertedResponseData.values.financialYear.map(
                      (financialYearList, idx) => {
                        let balanceSheetTemplateReq = {
                          validFromDate: moment(financialYearList.from).format(
                            "YYYY-MM-DD"
                          ),
                          validToDate: moment(financialYearList.to).format(
                            "YYYY-MM-DD"
                          ),
                          statementType: 2
                        };
                        mgmtStmtTemplateReqArray.push(balanceSheetTemplateReq);
                      }
                    );

                    axios
                      .post(
                        "/user/getAnnualReportTemplateDetails",
                        mgmtStmtTemplateReqArray,
                        userSessionAuthKeyReturnValue
                      )
                      .then((response) => {
                        if (Object.keys(response.data).length > 0) {
                          mgmtStmtTemplateResponse = response.data;
                          this.setState({
                            isLoading: false
                          });
                        } else {
                          this.setState({
                            isLoading: true
                          });
                        }

                        this.dataManipulation(
                          mgmtStmtTemplateResponse,
                          true,
                          false
                        );
                        tabTitleArray = mgmtStmtTemplateResponse;
                        this.openAll(mgmtStmtTemplateResponse);
                        this.rowColPreparation(mgmtStmtTemplateResponse);
                      });
                  }
                });
            }
          }
        });
    }

    tourGuidePages = localStorage.getItem("tourGuidePages");
    if (tourGuidePages != null) {
      tourGuidePages = JSON.parse(tourGuidePages);
      if (!tourGuidePages.includes(currentPageTourGuideName)) {
        tourGuidePages.push(currentPageTourGuideName);
      }
      localStorage.setItem("tourGuidePages", JSON.stringify(tourGuidePages));
    } else {
      let currentPageTourGuideArray = [];
      currentPageTourGuideArray.push(currentPageTourGuideName);
      localStorage.setItem(
        "tourGuidePages",
        JSON.stringify(currentPageTourGuideArray)
      );
    }
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateScreenSize);
  }
  updateScreenSize = () => {
    this.setState({ isMobile: window.innerWidth <= 1240 });
  };
  pageNavigation(navigateToPageName) {
    const { sessionDetails } = this.props;
    let { sideBarReducer } = this.props;
    const { mgmtStatementValue } = this.state;
    const annualReport = "/annualreport/";
    lastTextLineDetails.column1 = lastTextAreaText;
    this.txtAreaOnBlur(
      lastTextAreaText,
      lastTextAreaHeading,
      lastTextLineDetails,
      true
    );

    if (navigateToPageName == "representative") {
      let sideBarReducerValues = [];
      sideBarReducerValues = sideBarReducer.values;
      sideBarReducerValues.push("Management Statement");
      if (sideBarGreenTickPages == 0)
        sideBarReducer.values = sideBarReducerValues;

      let possibleAccessablePagesListLSString = localStorage.getItem(
        "possibleAccessablePages"
      );

      let possibleAccessablePagesListLSArray = JSON.parse(
        possibleAccessablePagesListLSString
      );

      // if (!possibleAccessablePagesListLSArray.includes("Representative")) {

      possibleAccessablePagesListLSArray.push(
        "Company Information",
        "Income Statement",
        "Balance Sheet",
        "Notes",
        "Management Statement"
        //"Representative"
      );

      possibleAccessablePagesListLSArray = [
        ...new Set(possibleAccessablePagesListLSArray)
      ];
      let updatePossibleNavigationPagesListString = JSON.stringify(
        possibleAccessablePagesListLSArray
      );

      localStorage.setItem(
        "possibleAccessablePages",
        updatePossibleNavigationPagesListString
      );
      // }

      const firstKey = Object.keys(mgmtStatementValue)[0];
      const firstValue = mgmtStatementValue[firstKey];
      const staticObj = firstValue.filter((i, idx) => i.dataType == "Static");

      const allNamesEmptyOrZero = staticObj.every(
        (item) =>
          item.column2 === "" ||
          item.column2 === "0" ||
          item.column2 === 0 ||
          item.column2 === null
      );

      if (allNamesEmptyOrZero) {
        this.toast.show({
          severity: "error",
          summary:
            TranslationFile.fillCityInManagementStatement[userSelectedLanguage],
          life: 2000
        });
        return "";
      }
    }
    this.props.history.push(
      annualReport + currentReportGUIDFromUrl + "/" + navigateToPageName
    );
  }

  dataManipulation(resp, isInitialRender, isOnChangeCall, linesDetails) {
    let {
      companyInformation,
      sessionDetails,
      login,
      managementStatus,
      financialYear,
      incomeStatement,
      balanceSheet
    } = this.props;

    const { mgmtStatementValue } = this.state;
    let fieldExistsInMultiYear = [];
    if (userSessionAuthKeyReturnValue) {
      delete resp.financialYearList;

      if (managementStatus.values != undefined && !isOnChangeCall) {
        // resp = managementStatus.values;
      } else {
        if (isInitialRender) {
          Object.keys(resp).map((i, idx) => {
            let sortedRespArray = [...resp[i]].sort(
              (a, b) => a.lineNo - b.lineNo
            );
            sortedRespArray.map((sortedResp, sortedRespIdx) => {
              sortedResp.column1 = sortedResp.name;
              sortedResp["reportGUID"] = currentReportGUIDFromUrl;
              sortedResp["createdByUserID"] =
                login == undefined ? 0 : login.userID;

              if (sortedResp.skMappingRange.includes("lineNo")) {
                //   let lineNo = sortedResp.skMappingRange.split(":")[1];
                sortedResp["lineSumRange"] = sortedResp.skMappingRange;
              }

              if (sortedResp.templateColumn2 != "") {
                if (sortedResp.templateColumn2.split("Date").length > 1) {
                  //set Fy from column2 to column 6 - START
                  let lastFy = "";
                  let fy = "";
                  let fyRange = "";

                  for (let j = 0; j < mgmtStmtTemplateReqArray.length; j++) {
                    let columnNo = "column" + (j + 2);
                    let DateNo = j + 1;
                    let templateColumnNo = "templateColumn" + (j + 2);
                    if (sortedResp[templateColumnNo] == "Date" + DateNo) {
                      if (mgmtStmtTemplateReqArray[j] != undefined) {
                        // fy =
                        //   mgmtStmtTemplateReqArray[j].validFromDate.split("-")[0];

                        fyRange =
                          mgmtStmtTemplateReqArray[j].validFromDate +
                          " - " +
                          mgmtStmtTemplateReqArray[j].validToDate;
                        sortedResp[columnNo] = fyRange;
                        lastFy = fy;

                        autoDate.from =
                          mgmtStmtTemplateReqArray[j].validFromDate;
                        autoDate.to = mgmtStmtTemplateReqArray[j].validToDate;
                      } else {
                        autoDate.from = moment(autoDate.from).subtract(
                          12,
                          "month"
                        )._d;
                        autoDate.to = moment(autoDate.from).subtract(
                          1,
                          "day"
                        )._d;

                        let fromDate = moment(autoDate.from).format(
                          "YYYY-MM-DD"
                        );
                        let toDate = moment(autoDate.to).format("YYYY-MM-DD");

                        let fromToDateRange = fromDate + " - " + toDate;

                        let lastFyFullDate = new Date(lastFy);
                        let prevFyFullDate = moment(lastFyFullDate).subtract(
                          1,
                          "years"
                        );
                        let prevFyYear = prevFyFullDate.year();
                        lastFy = prevFyYear.toString();

                        // sortedResp[columnNo] = lastFy;
                        sortedResp[columnNo] = fromToDateRange;
                        autoDate = {
                          from: fromDate,
                          to: toDate
                        };
                      }
                      financialYearLoc.push(lastFy);
                      financialYearLoc = [...new Set(financialYearLoc)];
                    } else {
                      sortedResp[columnNo] = sortedResp[templateColumnNo];
                    }
                  }
                  //set Fy from column2 to column 6 - END
                } else {
                  //set inside header column wise header from column2 to column 6 - START
                  sortedResp.column2 = sortedResp.templateColumn2;
                  if (sortedResp.column2 == "") {
                    delete sortedResp.column2;
                  }
                  sortedResp.column3 = sortedResp.templateColumn3;
                  if (sortedResp.column3 == "") {
                    delete sortedResp.column3;
                  }
                  sortedResp.column4 = sortedResp.templateColumn4;
                  if (sortedResp.column4 == "") {
                    delete sortedResp.column4;
                  }
                  sortedResp.column5 = sortedResp.templateColumn5;
                  if (sortedResp.column5 == "") {
                    delete sortedResp.column5;
                  }
                  sortedResp.column6 = sortedResp.templateColumn6;
                  if (sortedResp.column6 == "") {
                    delete sortedResp.column6;
                  }

                  if (sortedResp.templateColumn2 == "IXBRLTagOpen") {
                    sortedResp.column2 = "";
                  }

                  if (sortedResp.templateColumn2 == "IXBRLTagClose") {
                    // sortedResp.column2 = companyInformation.city;
                  }
                  //set inside header column wise header from column2 to column 6 - END
                }
              }

              let range = this.convert(sortedResp.range, "-");
              if (range[0] == 0) {
                range = this.convert(sortedResp.lineSumRange, "-");
              }

              if (companyInformation != undefined && range[0] != 0) {
                let fyArray = companyInformation.financialYear;
                let ffFormattedArray = [];
                fyArray.map((fyI, fyIdx) => {
                  ffFormattedArray.push(moment(fyI.from).format("YYYY"));
                });
              }
            });
          });
        }
      }

      delete resp.financialYearList;
      this.calcLineSumAmount(resp, false, "", "", "", linesDetails);
      fieldExistsInMultiYear = this.mergeMultiYearObject(resp);
      let lineDetailsArray = this.removeDuplicateLineNo(fieldExistsInMultiYear);

      lineDetailsArray.forEach((item, index) => {
        item.OrderNo = index + 1;
      });

      // Remove objects matching the condition
      lineDetailsArray = lineDetailsArray.filter(
        (item) =>
          !(
            item.lineLevel == 7 &&
            item.lineType == "Line" &&
            item.column1 == ""
          )
      );

      //uniqueArrList.filter((j)=>j.lineLevel==7 && j.lineType=="Line" && j.column1 == "")
      let lineNos = [];
      lineNos = lineDetailsArray.filter(
        (i) => i.mapToLineNo && i.mapToLineNo.includes("line")
      );

      if (lineNos.length > 0) {
        lineNos.forEach((i) => {
          const lineNo = Number(
            i.mapToLineNo && i.mapToLineNo.split("lineNo:")[1]
          );

          let matchedYearMap = {};

          // Collect both year 0 and -1 matchedObjs for this lineNo
          if (incomeStatement.values != undefined)
            Object.values(incomeStatement.values).forEach((section) => {
              section.forEach((item) => {
                if (item.lineNo === lineNo) {
                  matchedYearMap[item.financialYearValue] = item;
                }
              });
            });

          // For each section in resp, find matching lineNo items and update columns
          Object.values(resp).forEach((section) => {
            section.forEach((itemInside) => {
              if (itemInside.lineNo === Number(i.lineNo)) {
                const year = itemInside.financialYearValue;

                if (year === 0 && matchedYearMap[0]) {
                  i.column2 = matchedYearMap[0].lineAmount;
                  itemInside.column2 = matchedYearMap[0].lineAmount;
                }

                if (year === -1 && matchedYearMap[-1]) {
                  i.column3 = matchedYearMap[-1].lineAmount;
                  itemInside.column3 = matchedYearMap[-1].lineAmount;

                  // 👇 ensure column2 gets set even in case -1
                  if (matchedYearMap[0]) {
                    itemInside.column2 = matchedYearMap[0].lineAmount;
                  }
                }
              }
            });
          });
        });
      }

      if (
        lineDetailsArray.filter((i, idx) => i.column2 == "IXBRLTagClose")
          .length > 0
      ) {
        lineDetailsArray.filter(
          (i, idx) => i.column2 == "IXBRLTagClose"
        )[0].column2 = reportHeaderObj.city;
      }

      Object.keys(resp).map((i, idx) => {
        let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
        if (idx == 0) {
          if (
            sortedRespArray.filter((i, idx) => i.column2 == "IXBRLTagClose")
              .length > 0
          ) {
            sortedRespArray.filter(
              (i, idx) => i.column2 == "IXBRLTagClose"
            )[0].column2 = reportHeaderObj.city;
          }
        } else if (idx == 2) {
          let minusLogicLine = sortedRespArray.filter(
            (i) => i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
          );

          if (minusLogicLine.length > 0) {
            let detailsLineNos = [];
            detailsLineNos = sortedRespArray
              .filter(
                (i) => i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
              )[0]
              .mapToLineNo.split(":")[1]
              .split("-");

            let detailsLineObj = [];
            detailsLineObj = sortedRespArray.filter(
              (i) => i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
            );

            if (detailsLineObj.length > 0) {
              detailsLineObj = detailsLineObj[0];
              let finalValue =
                sortedRespArray.filter((i) => i.lineNo == detailsLineNos[0])[0]
                  .column2 -
                sortedRespArray.filter((i) => i.lineNo == detailsLineNos[1])[0]
                  .column2;
              detailsLineObj.column2 = finalValue;
            }
          }
        }
      });

      if (lineDetailsArray.length > 0) {
        axios
          .post(
            "/annualReportLine/insertLines",
            lineDetailsArray,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
              let responseJson = resp;
              responseJson["financialYearList"] = mgmtStmtTemplateReqArray;

              Object.entries(responseJson).forEach(([key, value]) => {
                let filteredItems = value.filter(
                  (item) =>
                    item.mapToLineNo && item.mapToLineNo.includes("calc:")
                );
                if (filteredItems.length > 0) {
                  // filteredResponse[key] = filteredItems;
                  let solidityCalLineNoList = [];
                  solidityCalLineNoList = filteredItems[0].mapToLineNo
                    .split(":")[1]
                    .split(",");

                  let solidityCalLineObj = [];

                  solidityCalLineNoList &&
                    solidityCalLineNoList.length &&
                    solidityCalLineNoList.map((lineNo, lineNoIdx) => {
                      // Find the object for the specified lineNo

                      if (balanceSheet.values != undefined)
                        Object.entries(balanceSheet.values).forEach(
                          ([key, value]) => {
                            value.forEach((item) => {
                              if (item.lineNo === parseInt(lineNo)) {
                                // result = item; // Store the item if the no matches
                                solidityCalLineObj.push(item);
                              }
                            });
                          }
                        );
                    });

                  if (solidityCalLineObj.length > 0) {
                    // Group by year
                    const groupedByYear = solidityCalLineObj.reduce(
                      (acc, item) => {
                        const year = item.year.split("-")[0]; // Extract the year
                        if (!acc[year]) {
                          acc[year] = [];
                        }
                        acc[year].push(item);
                        return acc;
                      },
                      {}
                    );

                    let solidityPercentage = [];
                    // Iterate over the grouped data
                    Object.keys(groupedByYear)
                      .sort((a, b) => b - a)
                      .forEach((year, yearIdx) => {
                        let lineAmountList = [];

                        groupedByYear[year].forEach((item) => {
                          lineAmountList.push(item.lineAmount);
                        });

                        if (lineAmountList.length > 1) {
                          let result =
                            (lineAmountList[0] / lineAmountList[1]) * 100;

                          solidityPercentage.push(result);
                        }
                      });

                    filteredItems.forEach((item) => {
                      item.column2 = solidityPercentage[0];
                      item.column3 = solidityPercentage[1];
                    });
                  }
                }
              });

              // Convert object to JSON string
              let jsonString = JSON.stringify(resp);

              // Replace "IXBRLTagClose" with an empty string
              jsonString = jsonString.replace(/IXBRLTagClose/g, "");

              // Convert the string back to an object
              let updatedResp = JSON.parse(jsonString);

              this.setState({
                mgmtStatementValue: updatedResp,
                isLoading: false
              });

              managementStatus.values = updatedResp;

              // if (userSessionAuthKeyReturnValue) {
              let currentPageName = localStorage.getItem("currentPageName");
              let updateJsonTableObj = {
                pageName: "Management Statement",
                guid: currentReportGUIDFromUrl,
                json: JSON.stringify(responseJson)
              };
              axios
                .post(
                  "/annualReportLine/updateLinesJsonTable",
                  updateJsonTableObj,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {});
              // }
            }
          });
      }

      // Convert object to JSON string
      let jsonString = JSON.stringify(resp);

      // Replace "IXBRLTagClose" with an empty string
      jsonString = jsonString.replace(/IXBRLTagClose/g, "");

      // Convert the string back to an object
      let updatedResp = JSON.parse(jsonString);

      this.setState({
        mgmtStatementValue: updatedResp,
        isLoading: false
      });

      managementStatus.values = updatedResp;
    }
  }

  convert = (str) =>
    str.split(",").flatMap((s) => {
      if (!s.includes("-")) return +s;
      const [min, max] = s.split("-");
      return Array.from({ length: max - min + 1 }, (_, n) => n + +min);
    });

  ParseFloat(str, val) {
    str = str.toString();
    str = str.slice(0, str.indexOf(".") + val + 1);
    return Number(str);
  }

  calcLineSumAmount(resp, insert, heading, amount, columnNo, lineDetails) {
    const { sessionDetails } = this.props;
    const { mgmtStatementValue } = this.state;
    if (userSessionAuthKeyReturnValue) {
      delete resp.financialYearList;
      let tempResp = { ...resp };
      Object.keys(resp).map((i, idx) => {
        let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
        let lineSumObjArray = sortedRespArray.filter((obj) => obj.isLineSum);

        lineSumObjArray &&
          lineSumObjArray.length &&
          lineSumObjArray.map((lineSumObj, lineSumObjIdx) => {
            let range = this.convert(lineSumObj.lineSumRange, "-");

            const lineObjPerHeader = sortedRespArray.filter(
              (obj) =>
                obj.lineType == "Line" ||
                obj.lineType == 2 ||
                obj.lineType == "Row Sum" ||
                obj.lineLevel == 3 ||
                obj.lineLevel == 4 ||
                obj.lineLevel == 7
            );

            let column2Value = 0,
              column3Value = 0,
              column4Value = 0,
              column5Value = 0,
              column6Value = 0;

            lineObjPerHeader &&
              lineObjPerHeader.length &&
              lineObjPerHeader.map((lineObj, lineObjIdx) => {
                if (range.includes(lineObj.lineNo)) {
                  if (lineObj.column2 != null) {
                    column2Value += Number(lineObj.column2);
                  }

                  if (lineObj.column3 != null) {
                    column3Value += Number(lineObj.column3);
                  }

                  if (lineObj.column4 != null) {
                    column4Value += Number(lineObj.column4);
                  }

                  if (lineObj.column5 != null) {
                    column5Value += Number(lineObj.column5);
                  }

                  if (lineObj.column6 != null) {
                    column6Value += Number(lineObj.column6);
                  }
                }
              });

            let isDecimalValue = false;

            if (null != column2Value) {
              isDecimalValue = column2Value % 1 != 0;
              lineSumObj.column2 = isDecimalValue
                ? this.ParseFloat(column2Value.toString(), 2)
                : column2Value;

              lineSumObj.column2 = Number(lineSumObj.column2);
            }

            if (null != column3Value) {
              isDecimalValue = column3Value % 1 != 0;
              lineSumObj.column3 = isDecimalValue
                ? this.ParseFloat(column3Value.toString(), 2)
                : column3Value;
              lineSumObj.column3 = Number(lineSumObj.column3);
            }

            if (null != column4Value) {
              isDecimalValue = column4Value % 1 != 0;
              lineSumObj.column4 = isDecimalValue
                ? this.ParseFloat(column4Value.toString(), 2)
                : column4Value;
              lineSumObj.column4 = Number(lineSumObj.column4);
            }

            if (null != column5Value) {
              isDecimalValue = column5Value % 1 != 0;
              lineSumObj.column5 = isDecimalValue
                ? this.ParseFloat(column5Value.toString(), 2)
                : column5Value;
              lineSumObj.column5 = Number(lineSumObj.column5);
            }

            if (null != column6Value) {
              isDecimalValue = column6Value % 1 != 0;
              lineSumObj.column6 = isDecimalValue
                ? this.ParseFloat(column6Value.toString(), 2)
                : column6Value;
              lineSumObj.column6 = Number(lineSumObj.column6);
            }

            //            if (idx == 2 && lineDetails.lineNo != 228000) {

            if (idx == 2) {
              let minusLogicLine = sortedRespArray.filter(
                (i) => i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
              );

              if (
                minusLogicLine.length > 0 &&
                lineDetails != undefined &&
                minusLogicLine[0].lineNo != lineDetails.lineNo
                // lineDetails.mapToLineNo != undefined &&
                // && minusLogicLine[0].parentLineNo == lineDetails.parentLineNo
              ) {
                let detailsLineNos = [];
                detailsLineNos = sortedRespArray
                  .filter(
                    (i) =>
                      i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
                  )[0]
                  .mapToLineNo.split(":")[1]
                  .split("-");

                let detailsLineObj = [];
                detailsLineObj = sortedRespArray.filter(
                  (i) =>
                    i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
                );

                if (detailsLineObj.length > 0) {
                  detailsLineObj = detailsLineObj[0];
                  let finalValue =
                    sortedRespArray.filter(
                      (i) => i.lineNo == detailsLineNos[0]
                    )[0].column2 -
                    sortedRespArray.filter(
                      (i) => i.lineNo == detailsLineNos[1]
                    )[0].column2;
                  detailsLineObj.column2 = finalValue;
                }
              }
            }
          });
      });

      this.setState({
        reRender: true
      });

      let lastAccordionTabKeyValue = Object.entries(resp)[2];
      let lastAccordionTabValue = lastAccordionTabKeyValue[1];

      let utdelningValue = lastAccordionTabValue.filter(
        (i) => (i.lineType = "Line" && i.lineLevel == 4)
      )[0];

      if (utdelningValue != undefined) {
        let lastTextArea = lastAccordionTabValue.filter(
          (i) => i.lineLevel == 5
        )[0];

        if (lastTextArea != undefined) {
          if (utdelningValue.column2 != 0) {
            lastTextArea.isVisible = true;
            lastTextArea.name = lastTextArea.placeHolder;
            lastTextArea.column1 = lastTextArea.placeHolder;
          } else {
            lastTextArea.isVisible = false;
          }
        }
      }

      let fieldExistsInMultiYear = this.mergeMultiYearObject(resp);
      let lineDetailsArray = this.removeDuplicateLineNo(fieldExistsInMultiYear);

      lineDetailsArray.forEach((item, index) => {
        item.OrderNo = index + 1;
      });

      // Remove objects matching the condition
      lineDetailsArray = lineDetailsArray.filter(
        (item) =>
          !(
            item.lineLevel == 7 &&
            item.lineType == "Line" &&
            item.column1 == ""
          )
      );

      if (insert && lineDetailsArray.length > 0) {
        axios
          .post(
            "/annualReportLine/insertLines",
            lineDetailsArray,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
              let responseJson = resp;
              responseJson["financialYearList"] = mgmtStmtTemplateReqArray;

              // if (userSessionAuthKeyReturnValue) {
              let currentPageName = localStorage.getItem("currentPageName");
              let updateJsonTableObj = {
                pageName: "Management Statement",
                guid: currentReportGUIDFromUrl,
                json: JSON.stringify(responseJson)
              };
              axios
                .post(
                  "/annualReportLine/updateLinesJsonTable",
                  updateJsonTableObj,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {});
            }
          });
      }
    }
  }

  sideBarStatus = (e) => {
    this.setState({
      sideBarStatus: e
    });
  };

  convert = (str) =>
    str.split(",").flatMap((s) => {
      if (!s.includes("-")) return +s;
      const [min, max] = s.split("-");
      return Array.from({ length: max - min + 1 }, (_, n) => n + +min);
    });

  accordionHeader(header) {
    return (
      <Row>
        <Col
          xs={5}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          style={{ width: "100%", marginTop: "7px" }}
        >
          <div>
            <label className="BSFieldsStyle">{header}</label>
          </div>
        </Col>
      </Row>
    );
  }

  mergeMultiYearObject(resp) {
    let fieldExistsInMultiYear = [];

    delete resp.financialYearList;
    Object.keys(resp).map((i, idx) => {
      // let sortedRespArray = [...resp[i]].sort((a, b) => a.lineNo - b.lineNo);
      let sortedRespArray = [...resp[i]];
      sortedRespArray.map((sortedResp, sortedRespIdx) => {
        const filtered = sortedRespArray.filter(
          (obj) => obj.lineNo == sortedResp.lineNo
        );

        if (filtered && filtered.length > 1) {
          let omitNull = (obj) => {
            Object.keys(obj)
              .filter((k) => obj[k] === null || obj[k] == undefined)
              .forEach((k) => delete obj[k]);
            return obj;
          };

          let objCollection = [];
          filtered.map((i, idx) => {
            if (i.column1 == "Comments") {
              i.column1 = "";
            }
            let cc = { ...omitNull(i) };
            objCollection.push(cc);
          });

          fieldExistsInMultiYear.push(Object.assign({}, ...objCollection));
        } else {
          fieldExistsInMultiYear.push(Object.assign({}, ...filtered));
        }
      });
    });

    return fieldExistsInMultiYear;
  }

  removeDuplicateLineNo(fieldExistsInMultiYear) {
    let lineNoArray = [],
      lineDetailsArray = [];

    fieldExistsInMultiYear.length &&
      fieldExistsInMultiYear.map((i, idx) => {
        let lineNoWiseObjArray = fieldExistsInMultiYear.filter(
          (obj) => obj.lineNo == i.lineNo
        );

        let arr = [];
        lineNoWiseObjArray &&
          lineNoWiseObjArray.length &&
          lineNoWiseObjArray.map((j, jdx) => {
            j = JSON.parse(JSON.stringify(j));
            Object.keys(j).forEach((key) => {
              if (j[key] == null) {
                delete j[key];
              }
            });
            arr.push(j);
          });
        const mergedLines = Object.assign({}, ...arr);

        if (!lineNoArray.includes(mergedLines.lineNo)) {
          lineNoArray.push(mergedLines.lineNo);
          lineDetailsArray.push(mergedLines);
        }
      });

    return lineDetailsArray;
  }

  onClickDeleteMatrixRow(lineDetail, headerName, groupIndex) {
    const { mgmtStatementValue } = this.state;

    if (userSessionAuthKeyReturnValue) {
      /**
       * Get groupNo from lineDetail.groupNo
       * Delete the groupNo objects from the state
       * Remove groupIndex Row from groupedData and update it
       *
       */

      let lineObjList = mgmtStatementValue[headerName];

      let groupNoToDelete = lineDetail.groupNo;
      let headerWiseLines = mgmtStatementValue[headerName];
      let deletedGroupNoObj = headerWiseLines.filter(
        (i) => i.groupNo != groupNoToDelete
      );

      mgmtStatementValue[headerName] = deletedGroupNoObj;
      groupedData.splice(groupIndex, 1);
      this.calculateMatrixSums(groupedData, lineDetail);

      //insert lines and json

      let mergedArray = [].concat(...Object.values(mgmtStatementValue));
      // Remove duplicates by `no`
      let uniqueArrList = mergedArray.reduce((acc, current) => {
        if (!acc.some((item) => item.no === current.no)) {
          acc.push(current);
        }
        return acc;
      }, []);

      if (uniqueArrList.length > 0) {
        uniqueArrList.forEach((item, index) => {
          item.OrderNo = index + 1; // Add OrderNo and increment by 1
        });

        // Remove objects matching the condition
        uniqueArrList = uniqueArrList.filter(
          (item) =>
            !(
              item.lineLevel == 7 &&
              item.lineType == "Line" &&
              item.column1 == ""
            )
        );

        let mapToLineNoWithDetailsLineNoObjList = [];
        mapToLineNoWithDetailsLineNoObjList = uniqueArrList.filter(
          (i) => i.mapToLineNo != null && i.mapToLineNo.includes("Detail")
        );

        let groupedDataLineSumRow = groupedData[groupedData.length - 1];

        mapToLineNoWithDetailsLineNoObjList &&
          mapToLineNoWithDetailsLineNoObjList.length &&
          mapToLineNoWithDetailsLineNoObjList.length > 0 &&
          mapToLineNoWithDetailsLineNoObjList.map((mapToLineNoObj, objIdx) => {
            let detailLineNo = Number(mapToLineNoObj.mapToLineNo.split(":")[1]);

            let detailsLineNoObj = [];
            detailsLineNoObj = groupedDataLineSumRow.filter(
              (item) => item.lineNo == detailLineNo
            );

            if (detailsLineNoObj.length > 0) {
              if (mapToLineNoObj.groupNo > 0) {
                let groupByMapToLineNoObj = [];
                groupByMapToLineNoObj =
                  mapToLineNoWithDetailsLineNoObjList.filter(
                    (item, itemIdx) => item.groupNo == mapToLineNoObj.groupNo
                  );

                groupByMapToLineNoObj &&
                  groupByMapToLineNoObj.length > 0 &&
                  groupByMapToLineNoObj.map((item, itemIdx) => {
                    item.column2 = detailsLineNoObj[0].column2;

                    let lineSumObj = [];
                    lineSumObj = uniqueArrList.filter(
                      (lineSumObjItem) =>
                        lineSumObjItem.parentLineNo == item.parentLineNo &&
                        lineSumObjItem.isLineSum
                    );

                    let lineSumValue = [];
                    lineSumValue = uniqueArrList
                      .filter(
                        (lineSumValueObj) =>
                          lineSumValueObj.parentLineNo == item.parentLineNo &&
                          !lineSumValueObj.isLineSum
                      )
                      .reduce(
                        (sum, item) =>
                          Number(
                            sum + (Number(item.column2) ? item.column2 : 0)
                          ),
                        0
                      );

                    if (lineSumObj.length > 0) {
                      lineSumObj[0].column2 = Number(lineSumValue);
                    }
                  });
              } else {
                // mapToLineNoObj.column2 = lineObjList.filter(
                //   (i) => i.lineNo == mapToLineNoObj.lineNo
                // )[0].column2;

                mapToLineNoObj.column2 = detailsLineNoObj[0].column2;

                let lineSumObj = [];
                lineSumObj = lineObjList.filter(
                  (lineSumObjItem) =>
                    lineSumObjItem.parentLineNo ==
                      mapToLineNoObj.parentLineNo && lineSumObjItem.isLineSum
                );

                let lineSumValue = [];
                lineSumValue = lineObjList
                  .filter(
                    (lineSumValueObj) =>
                      lineSumValueObj.parentLineNo ==
                        mapToLineNoObj.parentLineNo &&
                      !lineSumValueObj.isLineSum
                  )
                  .reduce(
                    (sum, item) =>
                      Number(sum + (Number(item.column2) ? item.column2 : 0)),
                    0
                  );

                if (lineSumObj.length > 0) {
                  lineSumObj[0].column2 = Number(lineSumValue);
                }
              }
              // mapToLineNoObj.column2 = detailsLineNoObj[0].column2;
            }

            //

            // if (
            //   uniqueArrList.filter((item) => item.lineNo == detailLineNo)
            //     .length > 0
            // ) {
            //   obj.column2 = Number(
            //     uniqueArrList.filter((item) => item.lineNo == detailLineNo)[0]
            //       .column2
            //   );

            //   let lineSumObj = [];
            //   lineSumObj = uniqueArrList.filter(
            //     (item) =>
            //       item.parentLineNo == obj.parentLineNo && item.isLineSum
            //   );
            //   let lineSumValue = uniqueArrList
            //     .filter(
            //       (i) => i.parentLineNo == obj.parentLineNo && !i.isLineSum
            //     )
            //     .reduce(
            //       (sum, item) =>
            //         Number(sum + (Number(item.column2) ? item.column2 : 0)),
            //       0
            //     );

            //   if (lineSumObj && lineSumObj.length && lineSumObj.length > 0) {
            //     lineSumObj[0].column2 = Number(lineSumValue);
            //   }
            // }
          });

        axios
          .post(
            "/annualReportLine/insertLines",
            uniqueArrList,
            userSessionAuthKeyReturnValue
          )
          .then((insertLinesResponse) => {
            if (insertLinesResponse.data) {
              this.updateLinesJsonTable(mgmtStatementValue);
            }
          });
      }

      this.setState({ reRender: false });
    }
  }

  calculateMatrixSums(groupedData, line) {
    let lineArray = groupedData.slice(0, groupedData.length - 1);

    // Initialize an array to store the sums for each position (1st, 2nd, etc.)
    let sums = [];

    // Determine the maximum length of the sub-arrays
    let maxLength = Math.max(...lineArray.map((subArray) => subArray.length));

    for (let i = 1; i < maxLength; i++) {
      let sum = 0;

      // Sum the 'no' values of the 'i'th object from each sub-array
      lineArray.forEach((subArray) => {
        if (subArray[i]) {
          sum += Number(subArray[i].column2);
        }
      });

      // Store the sum of the current position (1st, 2nd, etc.)
      sums.push(sum);
    }

    let lineSumArray = groupedData[groupedData.length - 1];

    lineSumArray &&
      lineSumArray.length > 0 &&
      lineSumArray.map((lineSum, lineSumIdx) => {
        if (lineSumIdx > 0) {
          lineSum.column2 = sums[lineSumIdx - 1];
        }
      });
  }

  onClickMatrixNewRowNew(lineDetail, headerName, groupIndex) {
    const { mgmtStatementValue } = this.state;

    let removeIdxArray = [];
    if (groupedData.length > 0) {
      groupedData.map((item, itemIdx) => {
        if (
          item.length > 0 &&
          item[0].isCustomRow != undefined &&
          item[0].isCustomRow == true &&
          item[0].column1 == ""
        ) {
          removeIdxArray.push(itemIdx);
        }
      });
    }

    // if (removeIdxArray.length > 1) {
    //   // Sort ppo in descending order to prevent index shifting
    //   removeIdxArray
    //     .sort((a, b) => b - a)
    //     .forEach((index) => {
    //       groupedData.splice(index, 1);
    //     });

    //   console.log(groupedData);
    // }

    // if (removeIdxArray.length == 0)
    //   groupedData.splice(groupedData.length - 1, 0, dummyCustArray);

    if (userSessionAuthKeyReturnValue && removeIdxArray.length == 0) {
      let addObj = { ...lineDetail };
      let lineNo = addObj.lineNo + 1;

      axios
        .get(
          "/annualReportDetails/getOptionForManagementMatrixColumn"
          // userSessionAuthKeyReturnValue
        )
        .then((matrixOptionResponse) => {
          let matrixOptionResponseData = matrixOptionResponse.data;
          if (matrixOptionResponseData.length > 0) {
            // Deep copy of the objects inside groupedData[0]
            let dummyCustArray = groupedData[0].map((i) => ({ ...i }));

            addIdx = groupedData.length - 1;

            // Modify the copy of dummyCustArray, not the original
            dummyCustArray.forEach((i) => {
              i.name = "";
              i.isCustomRow = true;
              i.column1 = "";
              i.column2 = "";
              i.column3 = "";
              i.column4 = "";
              i.column5 = "";
              i.column6 = "";
              i.lineNo = lineNo;
              // i.groupNo =
            });
            groupedData.splice(groupedData.length - 1, 0, dummyCustArray);

            // Group by `groupNo`
            grouped = matrixOptionResponseData.reduce((acc, item) => {
              const group = item.groupNo || "noGroup"; // Handle case when groupNo is undefined
              if (!acc[group]) {
                acc[group] = [];
              }
              acc[group].push(item);
              return acc;
            }, {});

            // Get the first element of each group
            const firstElements = Object.keys(grouped).map(
              (groupNo) => grouped[groupNo][0]
            );

            this.setState({
              items: []
            });

            //remove existing empty cust row - START
            let headerWiseLines = "";
            Object.keys(mgmtStatementValue).map((heading, idx) => {
              headerWiseLines = mgmtStatementValue[heading];

              let getEmprtCustomLine = headerWiseLines.filter(
                (item) =>
                  (item.isCustomRow == true && item.column1 != "") ||
                  item.isCustomRow == undefined
              );

              mgmtStatementValue[heading] = getEmprtCustomLine;
            });
            //remove existing empty cust row - END

            let suggestions = firstElements;
            let suggestionsList = [];
            suggestions &&
              suggestions.length &&
              suggestions.map((i, idx) => {
                let suggestionObj = {
                  id: idx + 1,
                  label: i.column1,
                  lineNo: i.lineNo,
                  groupNo: i.groupNo
                };
                suggestionsList.push(suggestionObj);
              });

            let firstObjects = groupedData.map((arr) => arr[0]);
            let renderLineNos = firstObjects.map((item) => item.groupNo);
            let nonMatchingSuggestions = suggestionsList.filter(
              (suggestion) => !renderLineNos.includes(suggestion.groupNo)
            );
            this.setState({
              items: nonMatchingSuggestions
            });

            //add cust row - START
            let headerResult = mgmtStatementValue[headerName];
            let calcNextLineNo = false;

            for (let i = addObj.lineNo; i <= addObj.lineNo + 1000; i++) {
              let lineNoObj = [];
              lineNoObj = headerResult.filter((obj) => obj.lineNo == i);
              if (lineNoObj.length == 0 && !calcNextLineNo) {
                lineNo = i;
                calcNextLineNo = true;
                break;
              }
            }

            custLineNo = lineNo;

            addObj.lineNo = lineNo;
            addObj.name = "";
            addObj.column1 = "";
            addObj.column2 = null;
            addObj.column3 = null;
            addObj.column4 = null;
            addObj.column5 = null;
            addObj.column6 = null;
            addObj.statementSubType = lineDetail.statementSubType;
            addObj.isCustomRow = true;
            addObj.lineType = "Line";

            let index = headerResult.findIndex(
              (item) => item.lineNo === lineDetail.lineNo
            );

            if (index !== -1) {
              // Insert the addObj next to the found object (after the found index)
              headerResult.splice(index + 1, 0, addObj);
            }

            this.setState({ reRender: true });
          }
        });
    }
  }

  onClickAddNewRow(lineDetail, headerName) {
    const { mgmtStatementValue } = this.state;

    if (userSessionAuthKeyReturnValue) {
      this.setState({
        items: []
      });

      //remove existing empty cust row - START
      Object.keys(mgmtStatementValue).map((heading, idx) => {
        let headerWiseLines = mgmtStatementValue[heading];

        let getEmprtCustomLine = headerWiseLines.filter(
          (item) =>
            (item.isCustomRow == true && item.column1 != "") ||
            item.isCustomRow == undefined
        );

        mgmtStatementValue[heading] = getEmprtCustomLine;
      });
      //remove existing empty cust row - END

      axios
        .get(
          "/siteOwner/getSuggestionListByParentLineNo?parentLineNo=" +
            lineDetail.parentLineNo,
          userSessionAuthKeyReturnValue
        )
        .then((suggestionResponse) => {
          if (suggestionResponse.data.length > 0) {
            let suggestions = suggestionResponse.data;

            let suggestionsList = [];
            suggestions &&
              suggestions.length &&
              suggestions.map((i, idx) => {
                let suggestionObj = {
                  id: idx + 1,
                  label: i.column1,
                  lineNo: i.lineNo,
                  groupNo: i.groupNo
                };
                suggestionsList.push(suggestionObj);
              });
            let headerLines = mgmtStatementValue[headerName];
            const filteredSuggestions = suggestionsList.filter(
              (suggestion) =>
                !headerLines.some((header) => header.name === suggestion.label)
            );
            this.setState({
              items: filteredSuggestions
              //newLineTextArea: false
            });

            let headerResult = mgmtStatementValue[headerName];
            let prevObj = headerResult.filter(
              (item) => item.lineNo == lineDetail.lineNo
            );

            let matchingIndices = headerResult
              .map((item, index) => (item.no === lineDetail.no ? index : -1)) // Map to index if it matches, -1 if not
              .filter((index) => index !== -1); // Filter out non-matching indices
            let fyHeaderList = headerResult.filter(
              (item) => item.lineNo == lineDetail.parentLineNo
            );

            let newLinesObjList = [];
            const usedLineNos = new Set();
            Object.values(mgmtStatementValue).forEach((rows) =>
              rows.forEach((r) => usedLineNos.add(r.lineNo))
            );
            let freeLineNo = lineDetail.lineNo + 1;
            while (usedLineNos.has(freeLineNo)) freeLineNo++;
            fyHeaderList &&
              fyHeaderList.length &&
              fyHeaderList.map((i, idx) => {
                let addObj = { ...lineDetail };
                // let lineNo = addObj.lineNo + 1;

                addObj.lineNo = freeLineNo;
                addObj.name = "";
                addObj.column1 = "";
                addObj.column2 = "";
                addObj.column3 = "";
                addObj.column4 = "";
                addObj.column5 = "";
                addObj.column6 = "";
                addObj.mapToLineNo = "";
                addObj.statementSubType = lineDetail.statementSubType;
                addObj.isCustomRow = true;
                addObj.disable = false;

                switch (idx) {
                  case 0:
                    addObj.financialYearRange = i.column2;
                    addObj.financialYearValue = idx;
                    addObj.year = i.column2.split(" - ")[0];
                    newLinesObjList.push(addObj);
                    break;
                  case 1:
                    addObj.financialYearRange = i.column3;
                    addObj.financialYearValue = idx;
                    addObj.year = i.column3.split(" - ")[0];
                    newLinesObjList.push(addObj);
                    break;
                  case 2:
                    addObj.financialYearRange = i.column4;
                    addObj.financialYearValue = idx;
                    addObj.year = i.column4.split(" - ")[0];
                    newLinesObjList.push(addObj);
                    break;
                  case 4:
                    addObj.financialYearRange = i.column5;
                    addObj.financialYearValue = idx;
                    addObj.year = i.column5.split(" - ")[0];
                    newLinesObjList.push(addObj);
                    break;
                }
              });

            // Find the indexes of all matching objects in arrList
            let indices = [];
            headerResult.forEach((item, index) => {
              if (item.no === lineDetail.no) {
                indices.push(index);
              }
            });

            // Insert elements from addList into arrList after the matched indices
            newLinesObjList.forEach((item, idx) => {
              if (indices[idx] !== undefined) {
                // Insert the element after the matched index

                switch (idx) {
                  case 0:
                    headerResult.splice(indices[idx] + 1, 0, item);
                    break;

                  case 1:
                    headerResult.splice(indices[idx] + 2, 0, item);
                    break;

                  case 2:
                    headerResult.splice(indices[idx] + 3, 0, item);
                    break;

                  case 3:
                    headerResult.splice(indices[idx] + 4, 0, item);
                    break;
                }
              }
            });

            this.setState({ reRender: true });
          } else {
            this.setState({
              items: []
            });
          }
        });
    }
  }

  addNewLineNew(prevObj, headerName) {
    const { mgmtStatementValue } = this.state;

    if (userSessionAuthKeyReturnValue) {
      //remove existing empty cust row - START
      Object.keys(mgmtStatementValue).map((heading, idx) => {
        let headerWiseLines = mgmtStatementValue[heading];

        let defaultHeaderWiseLines = headerWiseLines.filter(
          (obj) => obj.isCustomRow == undefined
        );

        let notEmptyCustRow = headerWiseLines.filter(
          (obj) => obj.isCustomRow && obj.name != ""
        );

        const mergedLines = [...defaultHeaderWiseLines, ...notEmptyCustRow];
        mgmtStatementValue[heading] = mergedLines;
      });
      //remove existing empty cust row - END

      let headerResult = mgmtStatementValue[headerName];
      let addObj = { ...prevObj };

      let lineNo = addObj.lineNo + 1;
    }
  }

  addNewLine(prevObj, headerName, lineDetailIdx) {
    const { mgmtStatementValue } = this.state;

    if (userSessionAuthKeyReturnValue) {
      //remove existing empty cust row - START
      Object.keys(mgmtStatementValue).map((heading, idx) => {
        let headerWiseLines = mgmtStatementValue[heading];

        let defaultHeaderWiseLines = headerWiseLines.filter(
          (obj) => obj.isCustomRow == undefined
        );

        let notEmptyCustRow = headerWiseLines.filter(
          (obj) => obj.isCustomRow && obj.name != ""
        );

        let kkr = headerWiseLines.filter(
          (obj) =>
            obj.isCustomRow == undefined || (obj.isCustomRow && obj.name != "")
        );

        const mergedLines = [...defaultHeaderWiseLines, ...notEmptyCustRow];
        // mgmtStatementValue[heading] = mergedLines;
        mgmtStatementValue[heading] = kkr;
      });
      //remove existing empty cust row - END

      //suggestion - START
      axios
        .get(
          "/siteOwner/getSuggestionListByParentLineNo?parentLineNo=" +
            prevObj.parentLineNo,
          userSessionAuthKeyReturnValue
        )
        .then((suggestionResponse) => {
          if (suggestionResponse.data.length > 0) {
            let suggestions = suggestionResponse.data;

            let suggestionsList = [];
            suggestions &&
              suggestions.length &&
              suggestions.map((i, idx) => {
                let suggestionObj = {
                  id: idx + 1,
                  label: i.column1,
                  lineNo: i.lineNo,
                  groupNo: i.groupNo
                };
                suggestionsList.push(suggestionObj);
              });

            this.setState({
              items: suggestionsList
            });
          }
        });

      //suggestion - END

      //add cust row - START
      let headerResult = mgmtStatementValue[headerName];
      let addObj = { ...prevObj };

      let lineNo = addObj.lineNo + 1;
      let calcNextLineNo = false;

      for (let i = addObj.lineNo; i <= addObj.lineNo + 1000; i++) {
        let lineNoObj = [];
        lineNoObj = headerResult.filter((obj) => obj.lineNo == i);
        if (lineNoObj.length == 0 && !calcNextLineNo) {
          lineNo = i;
          calcNextLineNo = true;
          break;
        }
      }

      addObj.lineNo = lineNo;
      addObj.name = "";
      addObj.column1 = "";
      addObj.column2 = null;
      addObj.column3 = null;
      addObj.column4 = null;
      addObj.column5 = null;
      addObj.column6 = null;
      addObj.statementSubType = prevObj.statementSubType;
      addObj.isCustomRow = true;
      addObj.mapToLineNo = "";
      // headerResult.push(addObj);
      //add cust row - EBD

      let index = headerResult.findIndex(
        (item) => item.lineNo === prevObj.lineNo
      );

      if (index !== -1) {
        // Insert the addObj next to the found object (after the found index)
        headerResult.splice(index + 1, 0, addObj);
      }

      // let addObjArray = [addObj];
      // axios
      //   .post(
      //     "/annualReportLine/insertLines",
      //     addObjArray,
      //     userSessionAuthKeyReturnValue
      //   )
      //   .then((response) => {
      //     if (response.data)
      this.setState({
        reRender: true
      });
      //   });
    }
  }

  txtAreaOnChange(text, heading, lineDetails) {
    const { mgmtStatementValue } = this.state;
    let headerWiseLines = mgmtStatementValue[heading];
    let objByLineNo = headerWiseLines.filter(
      (obj) => obj.lineNo == lineDetails.lineNo
    );

    lastTextAreaText = text;
    lastTextAreaHeading = heading;
    lastTextLineDetails = lineDetails;

    objByLineNo &&
      objByLineNo.length &&
      objByLineNo.map((i, idx) => {
        i.name = text;
        i.column1 = text;
      });

    if (objByLineNo && objByLineNo.length > 0) {
      selectedEditorObj = objByLineNo[0];
    }
    this.setState({
      reRender: true
    });
  }

  stringInputOnChange(e, parentHeading, lineNo) {
    const { mgmtStatementValue } = this.state;
    mgmtStatementValue[parentHeading]
      .filter((obj) => obj.lineNo == lineNo)
      .map((line, lineIdx) => {
        line.column2 = e.target.value;
      });

    this.setState({
      reRender: true
    });
  }

  stringInputOnBlur(e, parentHeading, lineNo) {
    const { mgmtStatementValue } = this.state;
    const { managementStatus } = this.props;

    let isStringInputUpdated = false;

    if (userSessionAuthKeyReturnValue) {
      mgmtStatementValue[parentHeading]
        .filter((obj) => obj.lineNo == lineNo)
        .map((line, lineIdx) => {
          if (!isStringInputUpdated) {
            isStringInputUpdated = true;
            line.column2 = e.target.value;
            line.column1 = line.name;

            axios
              .post(
                "/annualReportDetails/updateDetailsTextArea",
                line,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                if (response.data) {
                  let responseJson = mgmtStatementValue;
                  responseJson["financialYearList"] = mgmtStmtTemplateReqArray;

                  let splittedUrl = window.location.href.split("/");
                  let currentReportGUIDFromUrl =
                    splittedUrl[splittedUrl.length - 2];

                  let updateJsonTableObj = {
                    pageName: "Management Statement",
                    guid: currentReportGUIDFromUrl,
                    json: JSON.stringify(responseJson)
                  };

                  axios
                    .post(
                      "/annualReportLine/updateLinesJsonTable",
                      updateJsonTableObj,
                      userSessionAuthKeyReturnValue
                    )
                    .then((response) => {});
                }
              });
          }
        });

      this.setState({
        reRender: true
      });
    }
  }

  txtAreaOnBlur(text, heading, lineDetails, isInsert) {
    const { sessionDetails } = this.props;
    const { mgmtStatementValue } = this.state;
    if (userSessionAuthKeyReturnValue) {
      let headerWiseLines = mgmtStatementValue[heading];
      let objByLineNo =
        headerWiseLines != undefined &&
        headerWiseLines.filter((obj) => obj.lineNo == lineDetails.lineNo);

      selectedEditorObj = lineDetails;

      if (!isInsert) {
        objByLineNo &&
          objByLineNo.length &&
          objByLineNo.map((i, idx) => {
            i.name = text;
            i.column1 = text;
            i.isVisible = true;
          });
      }

      if (isInsert) {
        axios
          .post(
            "/annualReportDetails/updateDetailsTextArea",
            lineDetails,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
              let responseJson = mgmtStatementValue;
              responseJson["financialYearList"] = mgmtStmtTemplateReqArray;

              let currentPageName = localStorage.getItem("currentPageName");
              let updateJsonTableObj = {
                pageName: "Management Statement",
                guid: currentReportGUIDFromUrl,
                json: JSON.stringify(responseJson)
              };
              axios
                .post(
                  "/annualReportLine/updateLinesJsonTable",
                  updateJsonTableObj,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {});
            }
          });
      }

      this.setState({
        reRender: true
      });
    }
  }

  // amountOnBlur(amount, heading, lineDetails, headerLblIdx, columnNo) {
  //   const { mgmtStatementValue } = this.state;
  //   let amountRemovedComma = amount.target.value.replace(",", "");
  //   let parsedFloatAmount = Number(amountRemovedComma.replaceAll(/\s/g, ""));

  //   let spacesRemoved = amountRemovedComma.replaceAll(/\s/g, "");

  //   const firstChar = spacesRemoved.charAt(0);
  //   let minusArray = ["-", "−", "‑", "−"];
  //   if (minusArray.includes(firstChar)) {
  //     const newStr = spacesRemoved.slice(1);
  //     parsedFloatAmount = Number(-1 * newStr);
  //   } else parsedFloatAmount = Number(spacesRemoved);

  //   let headerWiseLines = mgmtStatementValue[heading];
  //   let objByLineNo = headerWiseLines.filter(
  //     (obj) => obj.lineNo == lineDetails.lineNo
  //   );

  //   let columnNoToUpdate = headerLblIdx + 2;

  //   if (isNaN(parsedFloatAmount)) {
  //     parsedFloatAmount = 0;
  //   }

  //   const uniqueLineObjects = [
  //     ...new Map(objByLineNo.map((item) => [item.lineNo, item])).values(),
  //   ];

  //   uniqueLineObjects &&
  //     uniqueLineObjects.length &&
  //     uniqueLineObjects.map((i, idx) => {
  //       let objByLineNoTemp = headerWiseLines.filter(
  //         (obj) => obj.lineNo == lineDetails.lineNo
  //       );

  //       const uniqueLineObjectsTemp = [
  //         ...new Map(
  //           objByLineNoTemp.map((item) => [item.lineNo, item])
  //         ).values(),
  //       ];

  //       uniqueLineObjectsTemp &&
  //         uniqueLineObjectsTemp.length &&
  //         uniqueLineObjectsTemp.map((o, odx) => {
  //           if (o.column2 != null) {
  //             i.column2 = o.column2;
  //           }

  //           if (o.column3 != null) {
  //             i.column3 = o.column3;
  //           }

  //           if (o.column4 != null) {
  //             i.column4 = o.column4;
  //           }

  //           if (o.column5 != null) {
  //             i.column5 = o.column5;
  //           }
  //           i.column6 = 0;
  //         });

  //       if (columnNo !== "6") {
  //         i["column" + columnNoToUpdate] = parsedFloatAmount;
  //       }
  //     });

  //   if (heading.includes("2 ", 0)) {
  //     objByLineNo &&
  //       objByLineNo.length &&
  //       objByLineNo.map((respObj, idx) => {
  //         let rowSum = 0;

  //         if (respObj.column2 != null) {
  //           rowSum += Number(respObj.column2);
  //         }

  //         if (respObj.column3 != null) {
  //           rowSum += Number(respObj.column3);
  //         }

  //         if (respObj.column4 != null) {
  //           rowSum += Number(respObj.column4);
  //         }

  //         if (respObj.column5 != null) {
  //           rowSum += Number(respObj.column5);
  //         }

  //         if (rowSum != 0) {
  //           if (columnNo == "6") {
  //             respObj.column6 = parsedFloatAmount;
  //           } else {
  //             respObj.column6 = rowSum;
  //           }
  //         }
  //       });

  //     let lineSumArray = headerWiseLines.filter((obj) => obj.isLineSum);
  //     lineSumArray &&
  //       lineSumArray.length &&
  //       lineSumArray.map((i, idx) => {
  //         let existingAmount = Number(i["column" + columnNoToUpdate]);
  //         i["column" + columnNoToUpdate] = existingAmount + parsedFloatAmount;
  //         // i["column" + columnNoToUpdate] = 10
  //       });
  //   }

  //   this.setState({
  //     reRender: true,
  //   });

  //   this.calcLineSumAmount(mgmtStatementValue, true);
  // }
  amountOnBlur(amount, heading, lineDetails, headerLblIdx, columnNo) {
    const { mgmtStatementValue } = this.state;

    let rawValue = amount?.target?.value ?? "";

    // If value is empty string, store as empty and skip parsing
    let isEmpty = rawValue.trim() === "";
    let parsedFloatAmount = isEmpty
      ? ""
      : (() => {
          // Remove comma and spaces
          let cleanValue = rawValue.replaceAll(",", "").replaceAll(/\s/g, "");

          // Handle minus signs
          const firstChar = cleanValue.charAt(0);
          const minusArray = ["-", "−", "‑", "‒"];

          let number = minusArray.includes(firstChar)
            ? -1 * Number(cleanValue.slice(1))
            : Number(cleanValue);

          return isNaN(number) ? "" : number;
        })();

    let headerWiseLines = mgmtStatementValue[heading];
    let objByLineNo = headerWiseLines.filter(
      (obj) => obj.lineNo == lineDetails.lineNo
    );

    let columnNoToUpdate = headerLblIdx + 2;

    const uniqueLineObjects = [
      ...new Map(objByLineNo.map((item) => [item.lineNo, item])).values()
    ];

    objByLineNo.forEach((i) => {
      let objByLineNoTemp = headerWiseLines.filter(
        (obj) => obj.lineNo == lineDetails.lineNo
      );

      const uniqueLineObjectsTemp = [
        ...new Map(objByLineNoTemp.map((item) => [item.lineNo, item])).values()
      ];

      uniqueLineObjectsTemp.forEach((o) => {
        if (o.column2 != null) i.column2 = o.column2;
        if (o.column3 != null) i.column3 = o.column3;
        if (o.column4 != null) i.column4 = o.column4;
        if (o.column5 != null) i.column5 = o.column5;
        i.column6 = 0;
      });

      if (columnNo !== "6") {
        i["column" + columnNoToUpdate] = parsedFloatAmount;
      }
    });

    if (heading.includes("2 ", 0)) {
      objByLineNo.forEach((respObj) => {
        let rowSum = 0;
        if (respObj.column2 != null) rowSum += Number(respObj.column2);
        if (respObj.column3 != null) rowSum += Number(respObj.column3);
        if (respObj.column4 != null) rowSum += Number(respObj.column4);
        if (respObj.column5 != null) rowSum += Number(respObj.column5);

        if (!isEmpty) {
          respObj.column6 = columnNo == "6" ? parsedFloatAmount : rowSum;
        }
      });

      let lineSumArray = headerWiseLines.filter((obj) => obj.isLineSum);
      if (!isEmpty) {
        lineSumArray.forEach((i) => {
          let existingAmount = Number(i["column" + columnNoToUpdate]) || 0;
          i["column" + columnNoToUpdate] = existingAmount + parsedFloatAmount;
        });
      }
    }

    this.setState({
      reRender: true
    });

    this.calcLineSumAmount(
      mgmtStatementValue,
      true,
      "",
      amount,
      "",
      lineDetails
    );
  }

  amountOnChange(amount, heading, lineDetails, headerLblIdx, columnNo) {
    const { mgmtStatementValue } = this.state;

    let headerWiseLines = mgmtStatementValue[heading];
    let objByLineNo = headerWiseLines.filter(
      (obj) => obj.lineNo == lineDetails.lineNo
    );

    let lineSumArray = headerWiseLines.filter((obj) => obj.isLineSum);

    let columnNoToUpdate = headerLblIdx + 2;

    objByLineNo &&
      objByLineNo.length &&
      objByLineNo.map((i, idx) => {
        if (idx == 0) {
          i["column" + columnNoToUpdate] = amount.value;
        } else {
          i["column" + columnNoToUpdate] = null;
        }
      });

    objByLineNo &&
      objByLineNo.length &&
      objByLineNo.map((respObj, idx) => {
        if (idx == 0) {
          let rowSum = 0;

          if (respObj.column2 != null) {
            rowSum += respObj.column2;
          }

          if (respObj.column3 != null) {
            rowSum += respObj.column3;
          }

          if (respObj.column4 != null) {
            rowSum += respObj.column4;
          }

          if (respObj.column5 != null) {
            rowSum += respObj.column5;
          }

          if (rowSum != 0) {
            if (columnNo == "6") {
              respObj.column6 = amount.value;
            } else {
              respObj.column6 = rowSum;
            }
          }
        }
      });

    lineSumArray &&
      lineSumArray.length &&
      lineSumArray.map((i, idx) => {
        i["column" + columnNoToUpdate] += amount.value;
      });

    this.setState({
      reRender: true
    });

    this.calcLineSumAmount(mgmtStatementValue, true);
  }

  deleteCustomRow(customRowToDelete, heading) {
    const { mgmtStatementValue } = this.state;
    if (userSessionAuthKeyReturnValue) {
      const rowsToDelete = Array.isArray(customRowToDelete)
        ? customRowToDelete
        : [customRowToDelete];
      let ObjectToDelete = Object.assign({}, ...rowsToDelete);
      Object.keys(mgmtStatementValue).map((i, idx) => {
        if (i == heading) {
          let filteredObjectsToRemove = mgmtStatementValue[i].filter(
            (item) => item.lineNo == ObjectToDelete.lineNo
          );
          filteredObjectsToRemove.length &&
            filteredObjectsToRemove.map((ObjToRemove, ObjToRemoveIdx) => {
              mgmtStatementValue[i].splice(
                mgmtStatementValue[i].indexOf(ObjToRemove),
                1
              );
            });
          axios
            .post(
              "/annualReportLine/deleteCustomLine",
              ObjectToDelete,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              if (response.data) {
                this.dataManipulation(mgmtStatementValue, false, true);
                this.setState({
                  reRender: true
                });
              }
            });
        }
      });

      let index = selectedCustOptions.indexOf(customRowToDelete.column1);
      if (index !== -1) {
        selectedCustOptions.splice(index, 1); // Removes the element at the found index
      }
    }
  }

  headerOnChange(e, lineDetail, col, heading) {
    const { mgmtStatementValue } = this.state;
    let headingValues = mgmtStatementValue[heading];
    let lineNoFiltered = headingValues.filter(
      (obj) => obj.lineNo == lineDetail.lineNo
    );

    let value = e.target.value;
    // if (e.target.value != "") {
    lineNoFiltered.map((i, idx) => {
      i[col] = value != "" ? value : " ";
      // i[col] = value != "" && value ;
      headerUpdateLineObj = i;
    });
    // }

    this.setState({
      reRender: true
    });
  }

  headerOnBlur() {
    const { mgmtStatementValue } = this.state;
    if (userSessionAuthKeyReturnValue) {
      axios
        .post(
          "/annualReportDetails/updateManagementStatementHeader",
          headerUpdateLineObj,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            let responseJson = mgmtStatementValue;
            responseJson["financialYearList"] = mgmtStmtTemplateReqArray;
            // if (userSessionAuthKeyReturnValue) {
            let currentPageName = localStorage.getItem("currentPageName");
            let updateJsonTableObj = {
              pageName: "Management Statement",
              guid: currentReportGUIDFromUrl,
              json: JSON.stringify(responseJson)
            };
            axios
              .post(
                "/annualReportLine/updateLinesJsonTable",
                updateJsonTableObj,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {});
            // }
          }
        });
    }
  }
  languageValue = (e) => {};

  // callback = (annualReport, session, link, status) => {
  //   const { sessionDetails } = this.props;
  //   if (status) {
  //     this.props.history.push(annualReport + session + link);
  //   }
  //   this.setState({
  //     reRender: true,
  //   });
  // };
  callback = (annualReport, session, link, status) => {
    let sessionFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      this.props.history.push(annualReport + sessionFromLS + link);
    }
    this.setState({
      reRender: true
    });
  };

  deleteColumn(lineDetail, colIdx, deleteColumnsUnderHeading) {
    const { mgmtStatementValue } = this.state;
    //Deleting Column5

    Object.keys(mgmtStatementValue).map((heading, headingIdx) => {
      if (heading == deleteColumnsUnderHeading) {
        let resp = [...mgmtStatementValue[heading]];
        let deleteCol = colIdx + 2;
        if (lineDetail.templateColumn2 != "Date1") {
          resp.map((val) => {
            delete val["column" + deleteCol];
          });
        }
      }
    });

    Object.keys(mgmtStatementValue).map((heading, headingIdx) => {
      if (heading == deleteColumnsUnderHeading) {
        let resp = [...mgmtStatementValue[heading]];

        let linesList = resp.filter(
          (obj) => obj.parentLineNo == lineDetail.lineNo
        );
        let deleteCol = colIdx + 2;
        linesList.map((respObj, respIdx) => {
          if (!respObj.isLineSum) {
            delete respObj["column" + deleteCol];
          } else {
            respObj["column" + deleteCol] = 0;
          }

          if (lineDetail.templateColumn2 == "Date1") {
            let moveFromCol = deleteCol + 1;
            respObj["column" + deleteCol] = respObj["column" + moveFromCol];
            delete respObj["column" + moveFromCol];
          } else {
          }
        });

        linesList = resp.filter((obj) => obj.lineType == "Line");
        linesList.map((respObj, idx) => {
          // if (idx == 0) {
          let rowSum = 0;

          if (respObj.column2 != null) {
            rowSum += respObj.column2;
          }

          if (respObj.column3 != null) {
            rowSum += respObj.column3;
          }

          if (respObj.column4 != null) {
            rowSum += respObj.column4;
          }

          if (respObj.column5 != null) {
            rowSum += respObj.column5;
          }

          if (rowSum != 0) {
            respObj.column6 = rowSum;
          }
          // }
        });
      }
    });

    this.setState({
      reRender: true
    });

    Object.keys(mgmtStatementValue).map((heading, headingIdx) => {
      if (heading == deleteColumnsUnderHeading) {
        let resp = [...mgmtStatementValue[heading]];
        let linesList = resp.filter(
          (obj) => obj.parentLineNo == lineDetail.lineNo
        );
        let totaltSumValue = 0;
        linesList.map((respObj, respIdx) => {
          if (respObj.lineLevel == 3 && !respObj.isHeader) {
            if (respObj.column6 != undefined)
              totaltSumValue = totaltSumValue + respObj.column6;
          }

          if (linesList.length == respIdx + 1) {
            respObj["column6"] = totaltSumValue;
          }
        });
      }
    });

    //colIdx
    let updateAction = "move";
    if (lineDetail.templateColumn2 != "Date1") {
      updateAction = "clear";
    }
    let deleteColumnObj = {
      columnNo: colIdx + 2,
      parentLineNo: lineDetail.parentLineNo,
      reportGUID: currentReportGUIDFromUrl,
      updateAction: updateAction
    };

    axios
      .post(
        "/annualReportDetails/deleteColumnInMgmtStmt",
        deleteColumnObj,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        if (response.data) {
          if (lineDetail.templateColumn2 != "Date1") {
          }
          let responseJson = mgmtStatementValue;
          responseJson["financialYearList"] = mgmtStmtTemplateReqArray;
          // if (userSessionAuthKeyReturnValue) {
          let currentPageName = localStorage.getItem("currentPageName");
          let updateJsonTableObj = {
            pageName: "Management Statement",
            guid: currentReportGUIDFromUrl,
            json: JSON.stringify(responseJson)
          };
          axios
            .post(
              "/annualReportLine/updateLinesJsonTable",
              updateJsonTableObj,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {});
        }
      });
    this.setState({
      reRender: true
    });

    this.toast.clear();
  }

  addColumn(lineDetail, addInHeading) {
    const { mgmtStatementValue } = this.state;
    let isFyHeading = lineDetail.templateColumn2 == "Date1" ? true : false;
    let columnLimit = isFyHeading ? 5 : 6;
    let arr = [];
    // if (isFyHeading) {
    Object.keys(mgmtStatementValue).map((heading, headingIdx) => {
      if (heading == addInHeading) {
        let resp = [...mgmtStatementValue[heading]];
        // resp = resp.filter(
        //   (obj) =>
        //     obj.parentLineNo == lineDetail.lineNo && obj.dataType != "Textarea"
        // );

        //LINE
        // resp.filter((obj)=>obj.parentLineNo == lineDetail.lineNo && obj.dataType != "Textarea")
        //HEADER
        // resp.filter((obj)=>obj.lineNo== lineDetail.lineNo)

        resp = resp.filter((obj) => obj.lineNo == lineDetail.lineNo);

        let headingFromResp = resp.filter((obj) => obj.isHeader);

        let headerArrayObj = headingFromResp[0];

        let columnToAdd = "",
          columnNoToAdd = 0;

        let lastFyInHeading = "";

        if (
          !isFyHeading &&
          headerArrayObj &&
          (headerArrayObj.column6 == undefined || headerArrayObj.column6 == "")
        ) {
          columnToAdd = "column6";
          columnNoToAdd = 6;
          lastFyInHeading = headerArrayObj.column5;
        }

        if (
          headerArrayObj.column5 == undefined ||
          headerArrayObj.column5.length == 0 ||
          headerArrayObj.column5.includes("Date")
        ) {
          columnToAdd = "column5";
          columnNoToAdd = 5;
          lastFyInHeading = headerArrayObj.column4;
        }

        if (
          headerArrayObj.column4 == undefined ||
          headerArrayObj.column4.length == 0 ||
          headerArrayObj.column4.includes("Date")
        ) {
          columnToAdd = "column4";
          columnNoToAdd = 4;
          lastFyInHeading = headerArrayObj.column3;
        }

        if (
          headerArrayObj.column3 == undefined ||
          headerArrayObj.column3.length == 0 ||
          headerArrayObj.column3.includes("Date")
        ) {
          columnToAdd = "column3";
          columnNoToAdd = 3;
          lastFyInHeading = headerArrayObj.column2;
        }

        let fyRange = "",
          splitFyByHiffin = [];
        if (lastFyInHeading != "") {
          splitFyByHiffin = lastFyInHeading.split(" - ");
          if (splitFyByHiffin.length == 2) {
            let fromDate = (autoDate.from = moment(splitFyByHiffin[0]).subtract(
              12,
              "month"
            )._d);

            let toDate = (autoDate.from = moment(splitFyByHiffin[0]).subtract(
              1,
              "day"
            )._d);

            // let toDate = moment(splitFyByHiffin[1]).subtract(1, "day")._d;

            fromDate = moment(fromDate).format("YYYY-MM-DD");
            toDate = moment(toDate).format("YYYY-MM-DD");
            fyRange = fromDate + " - " + toDate;
          }
        }

        let columnValueToAdd = "";
        if (columnToAdd != "") {
          columnToAdd = columnToAdd;
          this.setState({
            addColumnLimitbutton: false
          });
          resp.map((i, idx) => {
            if (!arr.includes(i.column1)) {
              arr.push(i.column1);

              if (i.isHeader) {
                i[columnToAdd] = fyRange != "" ? fyRange : "text here..";
              } else {
                if (splitFyByHiffin.length == 2) {
                  i[columnToAdd] = 0;
                }
              }
            } else if (i.isHeader) {
              i[columnToAdd] = fyRange != "" ? fyRange : "text here..";
            } else {
              delete i[columnToAdd];
            }
          });
        } else {
          this.setState({
            addColumnLimitbutton: true
          });
          this.toast.show({
            severity: "error",
            summary: TranslationFile.LimitReachedText[userSelectedLanguage],
            life: 2000
          });
        }
      }
    });

    this.setState({
      reRender: true
    });
    // }
  }

  navigateToPDF() {
    window.open(`#/annualreport/${currentReportGUIDFromUrl}/pdf`, "_blank");
  }

  sideBarCallback = (value) => {
    if (value) {
      this.toast.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
        life: 5000
      });
      this.setState({
        reRender: true
      });
    }
  };

  componentDidMount() {
    window.addEventListener("resize", this.updateScreenSize);
    if (this.state.run) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    let userTourGuide = JSON.parse(localStorage.getItem("TourGuide")) || false;
    setTimeout(() => {
      if (this.textAreaRef.current) {
        this.textAreaRef.current.focus();
      }
    }, 100);
    if (userTourGuide) {
      if (
        tourGuidePages != null &&
        tourGuidePages.length > 0 &&
        tourGuidePages.includes(currentPageTourGuideName)
      ) {
        setTimeout(() => {
          this.setState({ run: false });
        }, 200);
      } else {
        setTimeout(() => {
          this.setState({ run: true });
        }, 200);
      }
    }
  }

  tourStatus = (e) => {
    this.setState({ run: e });
  };

  highlightMatchedText = (label, value) => {
    // Split the label by the matched value and wrap the match with a span for styling
    const parts = label.split(new RegExp(`(${value})`, "i"));
    return parts.map((part, index) =>
      part.toLowerCase() === value.toLowerCase() ? (
        <span
          key={index}
          style={{ backgroundColor: "#2a55a5", color: "white" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  matrixOptionOnSelect = (selectedValue, line, colIndex, heading, groupRow) => {
    const { items, mgmtStatementValue } = this.state;

    line.column1 = selectedValue;

    if (selectedValue != "") {
      let matchedOptionFromItem = items.filter(
        (i) => i.label == selectedValue
      )[0];
      let listToAdd = grouped[matchedOptionFromItem.groupNo];

      let column1Obj = {
        lineNo: 1,
        name: listToAdd[0].column1,
        lineLevel: 6,
        parentLineNo: 0,
        columnNo: 1,
        groupNo: matchedOptionFromItem.groupNo
      };

      // Insert listToAdd as the first element of mainArray
      listToAdd.unshift(column1Obj);

      let updatedListToAdd = [];
      for (let i = 1; i <= 5; i++) {
        let filterByColumnNo = listToAdd.filter((j) => j.columnNo == i)[0];
        if (filterByColumnNo != undefined) {
          updatedListToAdd.push(filterByColumnNo);
        } else {
          updatedListToAdd.push(null);
        }
      }

      let kkr = mgmtStatementValue[heading];
      // Create a new array excluding the 0th index
      let newArrayWithoutFirst = listToAdd.slice(1);
      kkr = kkr.concat(newArrayWithoutFirst);

      mgmtStatementValue[heading] = kkr;

      // // Replace the array at position replaceIdx in mainArray with listToAdd
      groupedData[addIdx] = updatedListToAdd;
    }

    this.setState({ reRender: true });
  };

  handleSelect = (selectedValue, line, heading) => {
    const { items, mgmtStatementValue } = this.state;
    let selectedSuggestionOption = items.filter(
      (obj) => obj.label == selectedValue
    )[0];
    if (!selectedSuggestionOption) return;
    if (!selectedCustOptions.includes(selectedValue)) {
      selectedCustOptions.push(selectedValue);
    }
    let headerLines = mgmtStatementValue[heading];
    headerLines
      .filter((item) => item.lineNo == line.lineNo)
      .forEach((item) => {
        item.lineNo = selectedSuggestionOption.lineNo;
        item.column1 = selectedValue;
        item.name = selectedValue;
        item.disable = true;
      });
    this.setState({
      selectedValue,
      items: items.filter((i) => i.label !== selectedValue),
      reRender: true
    });
  };

  matrixCustomOnChange(value, template, heading, groupIndex) {
    const { mgmtStatementValue, items } = this.state;

    // if (groupRow != null ||groupRow != undefined){
    //   template = groupRow
    // }

    Object.keys(mgmtStatementValue).map((i, idx) => {
      // let filteredObjectsToRemove = mgmtStatementValue[i].filter(
      //   (item) => item.lineNo == custLineNo
      // );

      let filteredObjectsToRemove = groupedData[groupIndex];

      if (
        items.length > 0 &&
        items.some((item) =>
          item.label.toLowerCase().includes(value.toLowerCase())
        )
      ) {
        filteredObjectsToRemove.map((j, jdx) => {
          j.column1 = value;
        });

        this.setState({
          reRender: true,
          showNoMatchFound: false
        });
      } else {
        if (!this.state.isToastVisible) {
          this.toast.show({
            severity: "warn",
            summary: "Warn Message",
            detail: '"' + value + '"' + " is not exists in the list",
            life: 2000
          });
          this.setState({ isToastVisible: true });

          setTimeout(() => {
            this.setState({ isToastVisible: false });
          }, 2000);
        }

        this.setState({
          showNoMatchFound: true
        });
      }
    });
  }

  customOnChange(value, template, heading) {
    const { mgmtStatementValue, items } = this.state;

    // if (groupRow != null ||groupRow != undefined){
    //   template = groupRow
    // }

    Object.keys(mgmtStatementValue).map((i, idx) => {
      let filteredObjectsToRemove = mgmtStatementValue[i].filter(
        (item) => item.lineNo == template.lineNo
      );

      if (
        items.length > 0 &&
        items.some((item) =>
          item.label.toLowerCase().includes(value.toLowerCase())
        )
      ) {
        filteredObjectsToRemove.map((j, jdx) => {
          j.column1 = value;
        });

        this.setState({
          reRender: true,
          showNoMatchFound: false
        });
      } else {
        if (!this.state.isToastVisible) {
          this.toast.show({
            severity: "warn",
            summary: "Warn Message",
            detail: '"' + value + '"' + " is not exists in the list",
            life: 2000
          });
          this.setState({ isToastVisible: true });

          setTimeout(() => {
            this.setState({ isToastVisible: false });
          }, 2000);
        }

        this.setState({
          showNoMatchFound: true
        });
      }
    });
  }

  rowColPreparation(jsonConvertedResponseData) {
    Object.keys(jsonConvertedResponseData).map((heading, parentIdx) => {
      let isMatrixAppilable = jsonConvertedResponseData[heading].filter(
        (i) => i.columnNo > 0
      );
      if (isMatrixAppilable.length > 0) {
        let result = jsonConvertedResponseData[heading];

        // Sort by groupNo
        // result.sort((a, b) => a.groupNo - b.groupNo);

        let headerList = result.filter(
          (i) => i.lineLevel == 6 || i.lineLevel == 7 || i.lineLevel == 8
        );
        let uniqueHeaderList = headerList.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.lineNo === value.lineNo)
        );

        headers = uniqueHeaderList.filter((item) => item.lineLevel === 6);

        const title = {
          lineNo: 1,
          name: "Förändringar i eget kapital",
          lineLevel: 8,
          parentLineNo: 0,
          groupNo: 20,
          columnNo: 2
        };

        headers.unshift(title);

        // Filter row data (lineLevel = 7)
        const rows = uniqueHeaderList.filter((item) => item.lineLevel === 7);

        // Get unique groupNos dynamically
        uniqueGroupNos = [...new Set(rows.map((item) => item.groupNo))];

        // Separate lineLevel 8 rows
        lineLevel8Rows = uniqueHeaderList.filter(
          (item) => item.lineLevel === 8
        );

        // Get unique groupNos dynamically
        uniqueGroupNosForLineSum = [
          ...new Set(lineLevel8Rows.map((item) => item.groupNo))
        ];

        // Group rows by groupNo dynamically and place them according to columnNo
        groupedData = uniqueGroupNos.map((groupNo) => {
          return headers.map((header, hedaerIdx) => {
            // Find rows for this groupNo and header's parentLineNo and columnNo
            let filteredData = rows.filter(
              (row) =>
                row.groupNo === groupNo && row.columnNo === header.columnNo
            );

            return filteredData[0] || null; // Return the full object or null if no match
          });
        });

        groupedData &&
          groupedData.length &&
          groupedData.map((i, idx) => {
            let title = "";
            let groupNo = 0;
            i &&
              i.length &&
              i.map((j, jdx) => {
                if (j !== null) {
                  title = j.name != undefined ? j.name : j.column1;
                  groupNo = j.groupNo;
                }
              });
            let column1Obj = {
              lineNo: 1,
              name: title,
              lineLevel: 6,
              parentLineNo: 0,
              columnNo: 1,
              groupNo: groupNo
            };

            i[0] = column1Obj;
          });

        // Group rows by groupNo dynamically and place them according to columnNo
        const groupedDataForLineSum = uniqueGroupNosForLineSum.map(
          (groupNo) => {
            return headers.map((header, headerIdx) => {
              // Find rows for this groupNo and header's parentLineNo and columnNo
              const filteredData = lineLevel8Rows.filter(
                (row) =>
                  row.groupNo === groupNo && row.columnNo === header.columnNo
              );
              return filteredData[0] || null; // Return the full object or null if no match
            });
          }
        );

        // if (groupedDataForLineSum.length) {
        // }
        groupedData = groupedData.concat(groupedDataForLineSum);
      }
    });

    this.setState({ reRender: true });
  }

  handleCellClick = (header, value) => {
    selectedMatrixHeaderObj = header;
    selectedMatrixLineObj = value;
  };

  matrixInputOnBlur(amount, line, heading) {
    const { items, mgmtStatementValue } = this.state;

    let amountRemovedComma = amount.target.value.replace(",", "");

    const value = amountRemovedComma.replace(/\s/g, "").replace(/"/g, "");

    const numberFormattedAmount = Number(value);

    if (line.column2 != numberFormattedAmount) {
      let parsedFloatAmount = numberFormattedAmount;
      let spacesRemoved = amountRemovedComma.replaceAll(/\s/g, "");

      const firstChar = spacesRemoved.charAt(0);
      let minusArray = ["-", "−", "‑", "−"];
      if (minusArray.includes(firstChar)) {
        const newStr = spacesRemoved.slice(1);
        parsedFloatAmount = Number(-1 * newStr);
      } else parsedFloatAmount = Number(spacesRemoved);

      if (isNaN(parsedFloatAmount)) {
        parsedFloatAmount = 0;
      }

      line.column2 = parsedFloatAmount;
      line.statementType = "Management Statement";
      line.name = line.column1;

      let lineArray = groupedData.slice(0, groupedData.length - 1);

      let sum = 0;
      let totalSum = 0;
      if (lineArray.length) {
        lineArray.map((i, idx) => {
          let lineObj = i.filter(
            (j) => j != null && j.columnNo == line.columnNo
          )[0];
          if (lineObj != undefined) {
            sum += Number(lineObj.column2);
          }

          //update column5 sum value
          let lineSum = 0;
          i &&
            i.length &&
            i.map((j, jdx) => {
              if (j != null && j.column2 != undefined && j.columnNo != 5) {
                lineSum += Number(j.column2);
              }

              if (j != null && j.column2 != undefined && j.columnNo == 5) {
                j.column2 = lineSum;
                totalSum += lineSum;
              }
            });
        });
      }

      let groupedDataLineSumRow = groupedData[groupedData.length - 1];

      let lineSumArray = groupedData[groupedData.length - 1];
      let totalSumObj = lineSumArray[lineSumArray.length - 1];
      totalSumObj.column2 = totalSum;

      let lineSumObj = lineSumArray.filter(
        (i) => i.columnNo == selectedMatrixLineObj.columnNo
      )[0];

      lineSumObj["column2"] = sum;

      selectedMatrixLineObj = "";
      selectedMatrixHeaderObj = "";

      let result = groupedData.map((arr) => {
        // Find the last non-null item
        for (let i = arr.length - 1; i >= 0; i--) {
          if (arr[i] !== null) {
            return arr[i];
          }
        }
        return null; // if all are null
      });

      let headingLinesList = mgmtStatementValue[heading];

      result &&
        result.length > 0 &&
        result.map((i, idx) => {
          let filteredLine = headingLinesList.filter(
            (j) => j.lineNo == i.lineNo
          );
          if (filteredLine.length > 0) {
            filteredLine[0].column2 = i.column2;
          }
        });

      lineSumArray &&
        lineSumArray.length > 0 &&
        lineSumArray.map((i, idx) => {
          let filteredLine = headingLinesList.filter(
            (j) => j.lineNo == i.lineNo
          );
          if (filteredLine.length > 0) {
            filteredLine[0].column2 = i.column2;
          }
        });

      let mgmtStatementValueTemp = mgmtStatementValue;

      let changesInEquityObjList = [];
      Object.keys(mgmtStatementValueTemp).map((heading, headingIdx) => {
        // Matrix tab
        let lineObjList = mgmtStatementValueTemp[heading];

        if (headingIdx == 1) {
          let lineObj = [];
          lineObj = lineObjList.filter((i) => i.lineNo == line.lineNo);

          lineObj &&
            lineObj.length > 0 &&
            lineObj.map((i, idx) => {
              i.column2 = line.column2;
            });

          let lineSumObj = [];
          lineSumObj = lineObjList.filter(
            (i) => i.lineNo == totalSumObj.lineNo
          );

          lineSumObj &&
            lineSumObj.length > 0 &&
            lineSumObj.map((i, idx) => {
              i.column2 = totalSumObj.column2;
            });

          changesInEquityObjList = lineObjList;
        } else if (headingIdx == 2) {
          //last Tab

          let mapToLineNoObjList = [];
          mapToLineNoObjList = lineObjList.filter((item) => item.mapToLineNo);

          mapToLineNoObjList &&
            mapToLineNoObjList.length > 0 &&
            mapToLineNoObjList.map((mapToLineNoObj, mapToLineNoObjIdx) => {
              let detailsLineNo = mapToLineNoObj.mapToLineNo.split(":")[1];

              let detailsLineNoObj = [];
              detailsLineNoObj = groupedDataLineSumRow.filter(
                (item) => item.lineNo == detailsLineNo
              );

              let minusLogicLine = lineObjList.filter(
                (i) => i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
              );

              if (minusLogicLine.length > 0) {
                let detailsLineNos = [];
                detailsLineNos = lineObjList
                  .filter(
                    (i) =>
                      i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
                  )[0]
                  .mapToLineNo.split(":")[1]
                  .split("-");

                let detailsLineObj = [];
                detailsLineObj = lineObjList.filter(
                  (i) =>
                    i.mapToLineNo != null && i.mapToLineNo.includes("Minus")
                );

                if (detailsLineObj.length > 0) {
                  detailsLineObj = detailsLineObj[0];
                  let finalValue =
                    lineObjList.filter((i) => i.lineNo == detailsLineNos[0])[0]
                      .column2 -
                    lineObjList.filter((i) => i.lineNo == detailsLineNos[1])[0]
                      .column2;
                  detailsLineObj.column2 = finalValue;
                }
              }

              // if (detailsLineNoObj.length > 0) {
              if (mapToLineNoObj.groupNo > 0 || detailsLineNoObj.length > 0) {
                let groupByMapToLineNoObj = [];
                groupByMapToLineNoObj = mapToLineNoObjList.filter(
                  (item, itemIdx) => item.groupNo == mapToLineNoObj.groupNo
                );

                groupByMapToLineNoObj &&
                  groupByMapToLineNoObj.length > 0 &&
                  groupByMapToLineNoObj.map((item, itemIdx) => {
                    item.column2 = detailsLineNoObj[0].column2;

                    let lineSumObj = [];
                    lineSumObj = lineObjList.filter(
                      (lineSumObjItem) =>
                        lineSumObjItem.parentLineNo == item.parentLineNo &&
                        lineSumObjItem.isLineSum
                    );

                    let lineSumValue = [];
                    lineSumValue = lineObjList
                      .filter(
                        (lineSumValueObj) =>
                          lineSumValueObj.parentLineNo == item.parentLineNo &&
                          !lineSumValueObj.isLineSum
                      )
                      .reduce(
                        (sum, item) =>
                          Number(
                            sum + (Number(item.column2) ? item.column2 : 0)
                          ),
                        0
                      );

                    if (lineSumObj.length > 0) {
                      lineSumObj[0].column2 = Number(lineSumValue);
                    }
                  });
              } else {
                // mapToLineNoObj.column2 = lineObjList.filter(
                //   (i) => i.lineNo == mapToLineNoObj.lineNo
                // )[0].column2;

                if (detailsLineNoObj.length > 0)
                  mapToLineNoObj.column2 = detailsLineNoObj[0].column2;

                let lineSumObj = [];
                lineSumObj = lineObjList.filter(
                  (lineSumObjItem) =>
                    lineSumObjItem.parentLineNo ==
                      mapToLineNoObj.parentLineNo && lineSumObjItem.isLineSum
                );

                let lineSumValue = [];
                lineSumValue = lineObjList
                  .filter(
                    (lineSumValueObj) =>
                      lineSumValueObj.parentLineNo ==
                        mapToLineNoObj.parentLineNo &&
                      !lineSumValueObj.isLineSum
                  )
                  .reduce(
                    (sum, item) =>
                      Number(sum + (Number(item.column2) ? item.column2 : 0)),
                    0
                  );

                if (lineSumObj.length > 0) {
                  lineSumObj[0].column2 = Number(lineSumValue);
                }
              }
              // }
            });
        }
      });

      let mergedArray = [].concat(...Object.values(mgmtStatementValueTemp));

      // let updatedAar = this.fillColumns(mergedArray);

      if (mergedArray && mergedArray.length > 0) {
        mergedArray.forEach((i) => {
          let duplicateObjArray = mergedArray.filter(
            (j) => j.lineNo == i.lineNo
          );
          let validArray = duplicateObjArray.find(
            (j) =>
              j.column2 > 0 ||
              j.column3 > 0 ||
              j.column4 > 0 ||
              j.column5 > 0 ||
              j.column6 > 0
          );

          if (validArray) {
            duplicateObjArray
              .filter(
                (j) =>
                  j.column2 == 0 &&
                  j.column3 == 0 &&
                  j.column4 == 0 &&
                  j.column5 == 0 &&
                  j.column6 == 0
              )
              .forEach((a) => {
                a.name = a.column1;
                a.statementType = "Management Statement";
                a.column2 = validArray.column2;
                a.column3 = validArray.column3;
                a.column4 = validArray.column4;
                a.column5 = validArray.column5;
                a.column6 = validArray.column6;
              });
          }
        });
      }
      // Remove duplicates by `no`
      let uniqueArrList = mergedArray.reduce((acc, current) => {
        if (!acc.some((item) => item.lineNo === current.lineNo)) {
          acc.push(current);
        }
        return acc;
      }, []);

      if (uniqueArrList.length > 0) {
        uniqueArrList.forEach((item, index) => {
          item.OrderNo = index + 1; // Add OrderNo and increment by 1
        });

        uniqueArrList = uniqueArrList.filter(
          (item) =>
            !(
              item.lineLevel == 7 &&
              item.lineType == "Line" &&
              item.column1 == ""
            )
        );

        axios
          .post(
            "/annualReportLine/insertLines",
            uniqueArrList,
            userSessionAuthKeyReturnValue
          )
          .then((insertLinesResponse) => {
            if (insertLinesResponse.data) {
              this.updateLinesJsonTable(mgmtStatementValue);
            }
          });
      }
      // }

      this.setState({ reRender: true });
    }
  }

  // Function to fill missing col1 and col2 values
  fillColumns(arr) {
    // Group rows by 'no'
    const grouped = arr.reduce((acc, row) => {
      if (!acc[row.lineNo]) {
        acc[row.lineNo] = [];
      }
      acc[row.lineNo].push(row);
      return acc;
    }, {});

    // Iterate over each group and update rows
    Object.values(grouped).forEach((group) => {
      let validCol2 = "";
      let validCol3 = "";
      let validCol4 = "";
      let validCol5 = "";
      let validCol6 = "";

      // Find the first non-empty values in col1 and col2
      for (let row of group) {
        if (row.column2 !== "" && row.column2 !== "0" && !validCol2) {
          validCol2 = row.column2;
        }
        if (row.column3 !== "" && row.column3 !== "0" && !validCol3) {
          validCol3 = row.column3;
        }
      }

      // Update rows with missing col1 and col2
      group.forEach((row) => {
        if (row.column2 === "" || row.column2 === "0") {
          row.column2 = validCol2;
        }
        if (row.column3 === "" || row.column3 === "0") {
          row.column3 = validCol3;
        }
      });
    });

    return arr;
  }

  renderMatrixColumn(heading, lineDetailsArray) {
    const { items } = this.state;
    const { readOnly, showWIPStatus } = this.props;

    return (
      <div style={{ overflow: "hidden" }}>
        <Row>
          {headers &&
            headers.length > 0 &&
            headers.map((header, heradIdx) => (
              <Col
                xs={heradIdx == 0 ? 3 : 2}
                sm={heradIdx == 0 ? 3 : 2}
                md={heradIdx == 0 ? 3 : 2}
                lg={heradIdx == 0 ? 3 : 2}
                xl={heradIdx == 0 ? 3 : 2}
                key={header.lineNo}
              >
                <div
                  className={
                    heradIdx == 0 ? "matrixHeaderCol1Lbl" : "matrixHeaderLbl"
                  }
                >
                  {header.name}
                </div>
              </Col>
            ))}
        </Row>
{console.log(groupedData,'****')}
        {groupedData != undefined &&
          groupedData &&
          groupedData.length > 0 &&
          groupedData.map((groupRow, groupIndex) => (
            <Row key={groupIndex}>
              {groupRow.map((value, colIndex) => (
                <Col
                  xs={colIndex == 0 ? 3 : 2}
                  sm={colIndex == 0 ? 3 : 2}
                  md={colIndex == 0 ? 3 : 2}
                  lg={colIndex == 0 ? 3 : 2}
                  xl={colIndex == 0 ? 3 : 2}
                  key={colIndex}
                  onFocus={() => this.handleCellClick(headers[colIndex], value)}
                >
                  <div>
                    {value != null && value ? (
                      value.parentLineNo == 0 ||
                      (value.lineType == "Line Sum" && colIndex == 0) ? (
                        value.isCustomRow == undefined ? (
                          value.name
                        ) : (
                          items.length > 0 && (
                            <div>
                              <Autocomplete
                                getItemValue={(item) => item.label}
                                items={items.filter(
                                  (item) =>
                                    item.label != undefined &&
                                    item.label
                                      .toLowerCase()
                                      .includes(value.column1.toLowerCase())
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    key={item.id}
                                    style={{
                                      background: isHighlighted
                                        ? "lightgray"
                                        : "white",
                                      padding: "5px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #ddd"
                                    }}
                                    className="suggestionDiv"
                                  >
                                    {this.highlightMatchedText(
                                      item.label,
                                      value.column1
                                    )}
                                  </div>
                                )}
                                value={value.column1}
                                onSelect={(e) => {
                                  this.matrixOptionOnSelect(
                                    e,
                                    value,
                                    colIndex,
                                    heading,
                                    groupRow
                                  );
                                }}
                                onChange={(e) => {
                                  this.matrixCustomOnChange(
                                    e.target.value,
                                    value,
                                    heading,
                                    groupIndex
                                  );
                                }}
                                renderInput={(props) => (
                                  <textarea
                                    {...props}
                                    className="mngnt_textarea auto-resize-textareaa"
                                    disabled={value.disable}
                                  />
                                )}
                                inputProps={{
                                  ref: this.inputRef,
                                  onBlur: (e) =>
                                    this.validateForm(e, heading, value,groupIndex),

                                  disabled: readOnly.values && true,

                                  placeholder:
                                    TranslationFile.EnterYourDescriptionText[
                                      userSelectedLanguage
                                    ],

                                  style: {
                                    outline: "none",
                                    // width: "280px",
                                    whiteSpace: "pre-wrap",
                                    wordWrap: "break-word",
                                    overflowWrap: "break-word",
                                    resize: "none",
                                    minHeight: "40px",
                                    lineHeight: "1.5",
                                    padding: "5px",
                                    borderRadius: "10px",
                                    borderColor: "#cdcdcd",
                                    overflowY: "hidden",
                                    height:
                                      value.column1.length / 55 > 1.0
                                        ? Math.round(
                                            value.column1.length / 55
                                          ) +
                                          1 * 50 +
                                          8
                                        : Math.round(
                                            value.column1.length / 55
                                          ) *
                                            30 +
                                          8
                                  }
                                }}
                                renderMenu={(items, value, style) => (
                                  <div
                                    style={{
                                      ...style,
                                      marginTop: "5px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "360px",
                                      lineHeight: 2,
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)"
                                    }}
                                  >
                                    {this.renderMenu(items)}
                                  </div>
                                )}
                              />
                            </div>
                          )
                        )
                      ) : (
                        <div>
                          {value.lineType == "Line Sum" ||
                          ((value.lineType == "Row Sum" ||
                            value.lineType == 6) &&
                            true) ||
                          groupRow[0].name == "" ? (
                            <InputNumber
                              className="matrixInputNumberDisabled"
                              useGrouping={true}
                              locale="sv-SE"
                              disabled={true}
                              value={value.column2}
                            />
                          ) : (
                            <InputNumber
                              className="matrixInputNumber"
                              useGrouping={true}
                              locale="sv-SE"
                              value={value.column2}
                              onBlur={(e) =>
                                this.matrixInputOnBlur(e, value, heading)
                              }
                              disabled={linkSharedUser == 3 ? true : false}
                            />
                          )}

                          <div>
                            {value.lineType == "Row Sum" &&
                              groupIndex + 1 == colIndex && (
                                <i
                                  id="MgmtStmtAddNewMatrixLineIcon"
                                  className="fa fa-plus"
                                  aria-hidden="true"
                                  onClick={(e) =>
                                    this.onClickMatrixNewRowNew(
                                      value,
                                      heading,
                                      groupIndex
                                    )
                                  }
                                  title="Add New Line 3"
                                  style={{
                                    display: linkSharedUser == 3 && "none"
                                  }}
                                ></i>
                              )}
                          </div>

                          <div>
                            {value.lineType == 6 && !value.isDefault && (
                              <i
                                id="MgmtStmtDeleteIcon"
                                className="pi pi-trash"
                                aria-hidden="true"
                                onClick={(e) =>
                                  this.onClickDeleteMatrixRow(
                                    value,
                                    heading,
                                    groupIndex
                                  )
                                }
                                title="Delete Row"
                                style={{
                                  display: linkSharedUser == 3 && "none"
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      )
                    ) : (
                      <InputNumber
                        className="matrixDisabledInputNumber"
                        useGrouping={true}
                        locale="sv-SE"
                        disabled={true}
                      />
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          ))}
      </div>
    );
  }

  renderMenu(itemsOption) {
    const { items } = this.state;
    let customDropdownValues = [];
    itemsOption &&
      itemsOption.length &&
      itemsOption.map((i, idx) => {
        let children = i.props.children;
        let result = children
          .filter((item, index) => index % 2 === 0) // Filter out even indices
          .join("");

        if (
          !selectedCustOptions.includes(result) &&
          customDropdownValues.length < itemsOption.length
        ) {
          customDropdownValues.push(i);
        }
      });

    // customDropdownValues &&
    //   customDropdownValues.length &&
    //   customDropdownValues.map((i, idx) => {
    //     // let result = i.filter((item, index) => index % 2 !== 0);

    //     // Extracting characters at odd indices
    //     let result = i
    //       .filter((item, index) => index % 2 === 0) // Filter out even indices
    //       // .map((item, index) => i[index - 1]) // Get elements at odd indices (which are at index-1 for the filtered result)
    //       .join("");

    //   });
    // let opt = itemsOption.props.children;
    // let result = customDropdownValues.filter((item, index) => index % 2 !== 0); // Filter out even indices
    // .map((item, index) => opt[index - 1]) // Get elements at odd indices (which are at index-1 for the filtered result)
    // .join("");

    // let options= items.filter((item)=>item.)
    return (
      <>
        {customDropdownValues.length > 0 ? (
          customDropdownValues
        ) : (
          <div
            style={{
              padding: "5px",
              color: "gray"
            }}
          >
            No matches found
          </div>
        )}
      </>
    );
  }
  validateForm(e, parentHeading, lineDetail,groupIndex) {
    const { items, mgmtStatementValue } = this.state;
    if (!userSessionAuthKeyReturnValue) return;
    if (lineDetail.disable) return;
const isGroupRow = lineDetail.groupNo > 0 && lineDetail.lineLevel == 6;
    const customValue = e.target.value.trim();
    const headerLines = mgmtStatementValue[parentHeading] || [];
    
  let matchedObj = items.find(
      (item) => item.label.toLowerCase() === customValue.toLowerCase()
    );
    if (!matchedObj) {
      setTimeout(() => {
        const rows = (
          this.state.mgmtStatementValue[parentHeading] || []
        ).filter(
          (r) =>
            !r.disable && (r.column1 || "").trim() === customValue
        );
        if (isGroupRow) {this.onClickDeleteMatrixRow(lineDetail, parentHeading, groupIndex); return;}
        if (rows.length) this.deleteCustomRow(rows, parentHeading, true);
      }, 200);
      return;
    }
    selectedCustOptions.push(matchedObj.label);
    const oldLineNo = lineDetail.lineNo;
    headerLines
      .filter((item) => item.lineNo == oldLineNo)
      .forEach((item) => {
        item.column1 = matchedObj.label;
        item.name = matchedObj.label;
        item.nameTemp = matchedObj.label;
        item.lineNo = matchedObj.lineNo;
        item.disable = true;
      });
    lineDetail.column1 = matchedObj.label;
    lineDetail.name = matchedObj.label;
    lineDetail.lineNo = matchedObj.lineNo;
    lineDetail.disable = true;
    this.setState({ reRender: true });
    let mergedArray = [].concat(...Object.values(mgmtStatementValue));
    mergedArray.forEach((item, index) => (item.OrderNo = index + 1));
    mergedArray = mergedArray.filter(
      (item) =>
        !(item.lineLevel == 7 && item.lineType == "Line" && item.column1 == "")
    );
    if (mergedArray.length > 0) {
      axios
        .post(
          "/annualReportLine/insertLines",
          mergedArray,
          userSessionAuthKeyReturnValue
        )
        .then((res) => {
          if (res.data) this.updateLinesJsonTable(mgmtStatementValue);
        });
    }
  }
  /*  validateForm(e, parentHeading, lineDetail) {
    const { items, mgmtStatementValue } = this.state;
    if (userSessionAuthKeyReturnValue) {
      let customValue = e.target.value;
      let headerLines = "";
      if (customValue.length > 0) {
        let getMatchedItem = items.filter((item) => item.label == customValue);
        if (getMatchedItem.length > 0) {
          selectedCustOptions.push(customValue);
          let matchedObj = getMatchedItem[0];

          headerLines = mgmtStatementValue[parentHeading];
          let filterLine = headerLines.filter(
            (item) => item.lineNo == lineDetail.lineNo
          );
          let updateLine = filterLine.forEach((item) => {
            item.column1 = customValue;
            item.name = customValue;
            item.nameTemp = customValue;
            item.lineNo = matchedObj.lineNo;
          });
        }
      }

      if (headerLines != "") {
        let mergedArray = [].concat(...Object.values(mgmtStatementValue));
        // Remove duplicates by `no`
        let uniqueArrList = mergedArray.reduce((acc, current) => {
          if (!acc.some((item) => item.no === current.no)) {
            acc.push(current);
          }
          return acc;
        }, []);

        let oo = mgmtStatementValue;
        oo[parentHeading] = headerLines;

        if (mergedArray.length > 0) {
          mergedArray.forEach((item, index) => {
            item.OrderNo = index + 1; // Add OrderNo and increment by 1
          });

          mergedArray = mergedArray.filter(
            (item) =>
              !(
                item.lineLevel == 7 &&
                item.lineType == "Line" &&
                item.column1 == ""
              )
          );

          axios
            .post(
              "/annualReportLine/insertLines",
              mergedArray,
              userSessionAuthKeyReturnValue
            )
            .then((insertLinesResponse) => {
              if (insertLinesResponse.data) {
                this.updateLinesJsonTable(oo);
              }
            });
        }
      }
    }
  } */

  updateLinesJsonTable = (linesObj) => {
    let updateJsonTableObj = {
      pageName: "Management Statement",
      guid: currentReportGUIDFromUrl,
      json: JSON.stringify(linesObj)
    };

    axios
      .post(
        "/annualReportLine/updateLinesJsonTable",
        updateJsonTableObj,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {});
  };

  //   saveNotesBeforeAction() {
  //      const { items, mgmtStatementValue } = this.state;
  //  let mergedArray = [].concat(...Object.values(mgmtStatementValue));

  //  let oo = mgmtStatementValue;
  //       oo[parentHeading] = headerLines;

  // };

  render() {
    const {
      sideBarStatus,
      isLoading,
      mgmtStatementValue,
      activeIndex,
      toggleOpen,
      companyName,
      currentFinancialYear,
      headerDetails,
      pdfLoading,
      items,
      addColumnLimitbutton,
      accessLevel,
      isPixel
    } = this.state;
    let responsivePixel = window.innerWidth;
    const { readOnly, showWIPStatus } = this.props;
    delete mgmtStatementValue.financialYearList;
    let pageUnderWIP = false;
    if (showWIPStatus.values != undefined) {
      if (showWIPStatus.values) {
        pageUnderWIP = true;
      } else {
        pageUnderWIP = false;
      }
    }

    return (
      <div>
        <Joyride
          continuous
          run={this.state.run}
          disableBeacon={true}
          showProgress={false}
          showSkipButton
          steps={steps}
          scrollToFirstStep
          scrollToSteps={true}
          disableScrolling={false}
          scrollOffset={100}
          locale={{
            last: "End",
            back: "Back",
            next: "Next",
            skip: "Skip"
          }}
          styles={{
            options: {
              zIndex: 10000
            }
          }}
        />

        <Toast
          ref={(el) => {
            this.toast = el;
          }}
          className="companyInfoErrorToast"
          style={{ marginTop: "34%" }}
        ></Toast>

        {accessLevel == 4 ? (
          <NoAccess />
        ) : (
          <>
            <NavBarHeader
              callBack={this.callback}
              isAppPortal={true}
              isHomePage={false}
            />
            <div
              className={
                pageUnderWIP
                  ? "managementSideBarWithWIP"
                  : "managementStatementSideBar"
              }
            >
              <Sidebar
                children="Management Statement"
                sideBarStatus={this.sideBarStatus.bind(this)}
                sideBarCallback={this.sideBarCallback}
                tourStatus={this.tourStatus.bind(this)}
                forceClose={isPixel}
              />
            </div>

            <Row
              className={
                sideBarStatus ? "MSFYStyle" : "MSFYStyle-sidebar-close"
              }
              // className="MSFYStyle"
            >
              <div className="ISparent" style={{ height: "85px" }}>
                <Col xs={5} sm={5} md={5} lg={5} xl={12}>
                  <div>
                    <div className="Page_Title_manage_div">
                      <div className="Page_Title_T1_Management">
                        {companyName}
                      </div>
                      <div className="Page_Title_management_Year">
                        {currentFinancialYear}
                      </div>
                    </div>
                  </div>
                </Col>
                {/* <Col className="payment-pdf-toggle">
            <span>
              <Button
                type="button"
                icon="pi pi-file-pdf"
                outlined
                style={{ borderRadius: "70px", marginRight: "1%" }}
                // className="pdf_view_management"
                tooltip={TranslationFile.pdfPreview[userSelectedLanguage]}
                tooltipOptions={{ position: "bottom" }}
                // onClick={() => this.navigateToPDF()}
                // onClick={() => previewPdf(currentReportGUIDFromUrl)}
                onClick={() => this.previewPdfLocal(currentReportGUIDFromUrl)}
              />
            </span>

            <span>
              {toggleOpen == true ? (
                <Button
                  value={toggleOpen}
                  icon="pi pi-chevron-down"
                  title="Expand"
                  onClick={(e) => this.handleChange(toggleOpen)}
                  className="toggle-open"
                />
              ) : (
                <Button
                  value={toggleOpen}
                  icon="pi pi-chevron-up"
                  title="Collapse"
                  onClick={(e) => this.handleChange(toggleOpen)}
                  className="toggle-open"
                />
              )}
            </span>
          </Col> */}

                <Col
                  className={
                    sideBarStatus
                      ? "mngment-pdf-toggle"
                      : "mngment-pdf-toggle-sidebar-close"
                  }
                >
                  <PreviewPdfHeader
                    reportGuid={currentReportGUIDFromUrl}
                    arrowPosition={toggleOpen}
                    onButtonClick={() => this.handleChange(toggleOpen)}
                    onBeforePreview={() =>
                      this.txtAreaOnBlur("", "", selectedEditorObj, true)
                    }
                  />
                </Col>
              </div>
            </Row>

            <div className={sideBarStatus ? "MSSideBarOpen" : "MSSideBarClose"}>
              {isLoading ? (
                <div className="BSLoading">
                  <i
                    className="pi pi-spin pi-spinner"
                    style={{ fontSize: "2rem" }}
                  ></i>
                </div>
              ) : (
                <Row style={{ width: "100%" }}>
                  <Col
                    xs={8}
                    sm={8}
                    md={8}
                    lg={8}
                    xl={8}
                    className={
                      sideBarStatus
                        ? "MS_Main_Div"
                        : "MS_Main_Div MS_sidebar-close"
                    }
                  >
                    {mgmtStatementValue != undefined && (
                      <Accordion
                        multiple
                        activeIndex={activeIndex}
                        onTabChange={(e) =>
                          this.setState({ activeIndex: e.index })
                        }
                        ref={this.myRef}
                      >
                        {Object.keys(mgmtStatementValue).map(
                          (heading, parentIdx) => {
                            // if (parentIdx != 1) {
                            let responseArray = mgmtStatementValue[heading];
                            // responseArray = [...responseArray].sort(
                            //   (a, b) => a.lineNo - b.lineNo
                            // );

                            let lineDetailsArray =
                              this.removeDuplicateLineNo(responseArray);

                            let tabHeaderName = lineDetailsArray[0].name;

                            lineDetailsArray = lineDetailsArray.filter(
                              (obj) => !obj.isHeader || obj.lineLevel != 1
                            );
                            let headerLblArray = [];

                            if (lineDetailsArray && lineDetailsArray.length) {
                              return (
                                <AccordionTab
                                  header={this.accordionHeader(tabHeaderName)}
                                  ref={this.myRef}
                                  className="IS-Accordion-Tab"
                                >
                                  {parentIdx != 1
                                    ? lineDetailsArray.map(
                                        (lineDetail, lineDetailIdx) => {
                                          let isInsideHeader =
                                            lineDetail.isHeader;

                                          let isInsideHeaderWithoutColVal =
                                            isInsideHeader &&
                                            lineDetail.column2 != undefined &&
                                            lineDetail.column2.length == 0 &&
                                            lineDetail.column3 != undefined &&
                                            lineDetail.column3.length == 0 &&
                                            lineDetail.column4 != undefined &&
                                            lineDetail.column4.length == 0 &&
                                            lineDetail.column5 != undefined &&
                                            lineDetail.column5.length == 0 &&
                                            lineDetail.column6 != undefined &&
                                            lineDetail.column6.length == 0;

                                          let prevObj =
                                            lineDetailsArray[lineDetailIdx - 1];

                                          lineDetail.templateColumn2 != "" &&
                                            usedColumnNos.push("column2");

                                          lineDetail.templateColumn3 != "" &&
                                            usedColumnNos.push("column3");

                                          lineDetail.templateColumn4 != "" &&
                                            usedColumnNos.push("column4");

                                          lineDetail.templateColumn5 != "" &&
                                            usedColumnNos.push("column5");

                                          lineDetail.templateColumn6 != "" &&
                                            usedColumnNos.push("column6");

                                          usedColumnNos = [
                                            ...new Set(usedColumnNos)
                                          ];

                                          return (
                                            <>
                                              <Row
                                                className="BSFields"
                                                style={{
                                                  height:
                                                    lineDetail.dataType !=
                                                      "Textarea" &&
                                                    lineDetail.lineType ==
                                                      "Line" &&
                                                    "auto"
                                                }}
                                              >
                                                <Col
                                                  xs={5}
                                                  sm={5}
                                                  md={5}
                                                  lg={5}
                                                  xl={5}
                                                  className="mgmtHeaderMainDiv"
                                                >
                                                  <div
                                                    className="mgmtLblRowMainsideDiv"
                                                    style={{
                                                      background:
                                                        isInsideHeader &&
                                                        "#DBE2EF"
                                                    }}
                                                  >
                                                    {lineDetail.templateColumn2 !=
                                                      "" &&
                                                      linkSharedUser != 3 &&
                                                      lineDetail.dataType !==
                                                        "Textarea" &&
                                                      lineDetail.dataType !=
                                                        "" && (
                                                        <p
                                                          className="mgmtStmntAddNewColumn"
                                                          style={{
                                                            display:
                                                              lineDetail[
                                                                "column5"
                                                              ] &&
                                                              lineDetail.templateColumn2 !==
                                                                "Date1" &&
                                                              "none"
                                                          }}
                                                          onClick={() =>
                                                            this.addColumn(
                                                              lineDetail,
                                                              heading
                                                            )
                                                          }
                                                        >
                                                          {parseInt(
                                                            responsivePixel
                                                          ) < 1830 ? (
                                                            <span id="addNewColumnMS">
                                                              <i
                                                                className="pi pi-plus"
                                                                style={{
                                                                  fontSize:
                                                                    "1rem",
                                                                  color: "green"
                                                                }}
                                                              ></i>
                                                            </span>
                                                          ) : (
                                                            <span id="addNewColumnMS">
                                                              + Add New Column
                                                            </span>
                                                          )}

                                                          {/* ) : (
                                                             ""
                                                           )}  */}
                                                        </p>
                                                      )}
                                                    {lineDetail.dataType !=
                                                    "Textarea" ? (
                                                      isInsideHeaderWithoutColVal ? (
                                                        <div className="mgmtIsInsideHeaderWithoutColVal">
                                                          <label className="mgmtIsInsideHeaderWithoutColValLbl">
                                                            {lineDetail.name}
                                                          </label>
                                                        </div>
                                                      ) : (
                                                        <Row
                                                          style={{
                                                            display:
                                                              "-webkit-box"
                                                          }}
                                                        >
                                                          <Col
                                                            xs={3}
                                                            sm={3}
                                                            md={3}
                                                            lg={3}
                                                            xl={3}
                                                          >
                                                            {lineDetail.isLineSum ? (
                                                              <div>
                                                                <label className="mgmtLineSumLbl">
                                                                  {
                                                                    lineDetail.name
                                                                  }
                                                                </label>
                                                              </div>
                                                            ) : lineDetail.name !=
                                                                "" &&
                                                              lineDetail.isCustomRow ==
                                                                undefined ? (
                                                              <div
                                                                className="Management_location_descrp"
                                                                style={{
                                                                  display:
                                                                    lineDetail.dataType ==
                                                                      "Static" &&
                                                                    "ruby-text"
                                                                }}
                                                              >
                                                                <label className="mgmtLineLbl">
                                                                  {
                                                                    lineDetail.name
                                                                  }
                                                                </label>

                                                                {lineDetail.dataType ==
                                                                  "Static" && (
                                                                  <InputText
                                                                    value={
                                                                      lineDetail.column2 !=
                                                                        null &&
                                                                      lineDetail.column2 !=
                                                                        0
                                                                        ? lineDetail.column2
                                                                        : ""
                                                                    }
                                                                    className="notesStringBox"
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      this.stringInputOnChange(
                                                                        e,
                                                                        heading,
                                                                        lineDetail.lineNo
                                                                      );
                                                                    }}
                                                                    onBlur={(
                                                                      e
                                                                    ) => {
                                                                      this.stringInputOnBlur(
                                                                        e,
                                                                        heading,
                                                                        lineDetail.lineNo
                                                                      );
                                                                    }}
                                                                    disabled={
                                                                      linkSharedUser ==
                                                                      3
                                                                    }
                                                                    style={{
                                                                      marginLeft:
                                                                        "20px",
                                                                      width:
                                                                        "60%",
                                                                      height:
                                                                        "40px"
                                                                    }}
                                                                  />
                                                                )}
                                                              </div>
                                                            ) : (
                                                              <div className="managementStmtNonDynamicColumnsLine">
                                                                {/* Cust LINE */}

                                                                <Autocomplete
                                                                  getItemValue={(
                                                                    item
                                                                  ) =>
                                                                    item.label
                                                                  }
                                                                  items={this.state.items.filter(
                                                                    (item) =>
                                                                      item.label
                                                                        .toLowerCase()
                                                                        .includes(
                                                                          lineDetail.column1.toLowerCase()
                                                                        )
                                                                  )}
                                                                  renderItem={(
                                                                    item,
                                                                    isHighlighted
                                                                  ) => (
                                                                    <div
                                                                      key={
                                                                        item.id
                                                                      }
                                                                      style={{
                                                                        background:
                                                                          isHighlighted
                                                                            ? "lightgray"
                                                                            : "white",
                                                                        padding:
                                                                          "5px",
                                                                        cursor:
                                                                          "pointer",
                                                                        borderBottom:
                                                                          "1px solid #ddd"
                                                                      }}
                                                                      className="suggestionDiv"
                                                                    >
                                                                      {this.highlightMatchedText(
                                                                        item.label,
                                                                        lineDetail.column1
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                  value={
                                                                    lineDetail.column1
                                                                  }
                                                                  onSelect={(
                                                                    e
                                                                  ) => {
                                                                    this.handleSelect(
                                                                      e,
                                                                      lineDetail,
                                                                      heading
                                                                    );
                                                                  }}
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    this.customOnChange(
                                                                      e.target
                                                                        .value,
                                                                      lineDetail,
                                                                      heading
                                                                    );
                                                                  }}
                                                                  renderInput={(
                                                                    props
                                                                  ) => (
                                                                    <textarea
                                                                      {...props}
                                                                      className="mngnt_textarea auto-resize-textareaa"
                                                                      disabled={
                                                                        lineDetail.disable
                                                                      }
                                                                    />
                                                                  )}
                                                                  inputProps={{
                                                                    ref: this
                                                                      .inputRef,
                                                                    onBlur: (
                                                                      e
                                                                    ) =>
                                                                      this.validateForm(
                                                                        e,
                                                                        heading,
                                                                        lineDetail
                                                                      ),

                                                                    disabled:
                                                                      readOnly.values &&
                                                                      true,

                                                                    placeholder:
                                                                      TranslationFile
                                                                        .EnterYourDescriptionText[
                                                                        userSelectedLanguage
                                                                      ],

                                                                    style: {
                                                                      outline:
                                                                        "none",

                                                                      whiteSpace:
                                                                        "pre-wrap",
                                                                      wordWrap:
                                                                        "break-word",
                                                                      overflowWrap:
                                                                        "break-word",
                                                                      resize:
                                                                        "none",
                                                                      minHeight:
                                                                        "40px",
                                                                      lineHeight:
                                                                        "1.5",
                                                                      padding:
                                                                        "5px",
                                                                      borderRadius:
                                                                        "10px",
                                                                      borderColor:
                                                                        "#cdcdcd",
                                                                      overflowY:
                                                                        "hidden",
                                                                      height:
                                                                        lineDetail
                                                                          .column1
                                                                          .length /
                                                                          55 >
                                                                        1.0
                                                                          ? Math.round(
                                                                              lineDetail
                                                                                .column1
                                                                                .length /
                                                                                55
                                                                            ) +
                                                                            1 *
                                                                              50 +
                                                                            8
                                                                          : Math.round(
                                                                              lineDetail
                                                                                .column1
                                                                                .length /
                                                                                55
                                                                            ) *
                                                                              30 +
                                                                            8
                                                                    }
                                                                  }}
                                                                  renderMenu={(
                                                                    items,
                                                                    value,
                                                                    style
                                                                  ) => (
                                                                    <div
                                                                      style={{
                                                                        ...style,
                                                                        marginTop:
                                                                          "5px",
                                                                        maxHeight:
                                                                          "200px",
                                                                        overflowY:
                                                                          "auto",
                                                                        width:
                                                                          "360px",
                                                                        lineHeight: 2,
                                                                        boxShadow:
                                                                          "0px 4px 6px rgba(0, 0, 0, 0.1)"
                                                                      }}
                                                                    >
                                                                      {this.renderMenu(
                                                                        items
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                />
                                                              </div>
                                                            )}
                                                          </Col>

                                                          {usedColumnNos.map(
                                                            (col, colIdx) => {
                                                              let convertedToNumb =
                                                                parseFloat(
                                                                  lineDetail[
                                                                    col
                                                                  ]
                                                                );

                                                              if (
                                                                lineDetail[
                                                                  col
                                                                ] != "" &&
                                                                lineDetail[
                                                                  col
                                                                ] != null &&
                                                                lineDetail[
                                                                  col
                                                                ] != "-" &&
                                                                lineDetail[
                                                                  "dataType"
                                                                ] != "" &&
                                                                lineDetail[
                                                                  "lineType"
                                                                ] != "Line" &&
                                                                !headerLblArray.includes(
                                                                  col
                                                                ) &&
                                                                !lineDetail[
                                                                  col
                                                                ].includes(
                                                                  "Date"
                                                                )
                                                              ) {
                                                                headerLblArray.push(
                                                                  col
                                                                );

                                                                if (
                                                                  lineDetail[
                                                                    col
                                                                  ] != ""
                                                                ) {
                                                                  return (
                                                                    <Col
                                                                      xs={2}
                                                                      sm={2}
                                                                      md={2}
                                                                      lg={2}
                                                                      xl={2}
                                                                      className="management_lineDetails_tempCol2"
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        marginTop:
                                                                          "3px"
                                                                      }}
                                                                    >
                                                                      <InputText
                                                                        value={
                                                                          lineDetail[
                                                                            col
                                                                          ]
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) =>
                                                                          this.headerOnChange(
                                                                            e,
                                                                            lineDetail,
                                                                            col,
                                                                            heading
                                                                          )
                                                                        }
                                                                        onBlur={() =>
                                                                          this.headerOnBlur()
                                                                        }
                                                                        className="fromToDateHeader"
                                                                        disabled
                                                                        // disabled={
                                                                        //   linkSharedUser ==
                                                                        //   3
                                                                        //     ? true
                                                                        //     : colIdx <
                                                                        //       companyInfoFinancialYear.length
                                                                        //     ? true
                                                                        //     : false
                                                                        // }
                                                                      />

                                                                      {linkSharedUser !=
                                                                        3 &&
                                                                        colIdx >=
                                                                          companyInfoFinancialYear.length && (
                                                                          <i
                                                                            id={
                                                                              parentIdx ==
                                                                                0 &&
                                                                              lineDetailIdx ==
                                                                                7 &&
                                                                              colIdx ==
                                                                                3
                                                                                ? "mgmtDeleteHeader"
                                                                                : "mgmtDeleteHeader1"
                                                                            }
                                                                            className="fa fa-times-circle"
                                                                            aria-hidden="true"
                                                                            style={{
                                                                              display:
                                                                                linkSharedUser ==
                                                                                  3 &&
                                                                                "none",
                                                                              visibility:
                                                                                lineDetail.templateColumn2 ==
                                                                                "Date1"
                                                                                  ? colIdx +
                                                                                      1 <=
                                                                                      mgmtStmtTemplateReqArray.length &&
                                                                                    "hidden"
                                                                                  : col ==
                                                                                      "column5"
                                                                                    ? "visible"
                                                                                    : "hidden"
                                                                            }}
                                                                            onClick={() => {
                                                                              this.deleteColumn(
                                                                                lineDetail,
                                                                                colIdx,
                                                                                heading
                                                                              );
                                                                            }}
                                                                          ></i>
                                                                        )}
                                                                    </Col>
                                                                  );
                                                                }
                                                              }
                                                            }
                                                          )}

                                                          {headerLblArray.map(
                                                            (
                                                              headerLbl,
                                                              headerLblIdx
                                                            ) => {
                                                              let columnNo =
                                                                headerLbl.split(
                                                                  "column"
                                                                )[1];

                                                              if (
                                                                lineDetail.lineType ==
                                                                  "Line" &&
                                                                lineDetail.dataType ==
                                                                  ""
                                                              ) {
                                                                return (
                                                                  <Col
                                                                    xs={2}
                                                                    sm={2}
                                                                    md={2}
                                                                    lg={2}
                                                                    xl={2}
                                                                    style={
                                                                      {
                                                                        // width:
                                                                        //   lineDetail.lineLevel ==
                                                                        //   3
                                                                        //     ? lineDetail.isCustomRow ==
                                                                        //         undefined ||
                                                                        //       !lineDetail.isCustomRow
                                                                        //       ? ""
                                                                        //       : headerLblArray.length ==
                                                                        //         headerLblIdx +
                                                                        //           1
                                                                        //       ? "100%"
                                                                        //       : "15%"
                                                                        //     : "12%",
                                                                        // display:
                                                                        //   lineDetail.lineLevel ==
                                                                        //     3 &&
                                                                        //   lineDetail.isCustomRow !=
                                                                        //     undefined &&
                                                                        //   lineDetail.isCustomRow &&
                                                                        //   headerLblArray.length ==
                                                                        //     headerLblIdx +
                                                                        //       1 &&
                                                                        //   "inline-flex",
                                                                        // : lineDetail.lineLevel ==
                                                                        //     3 &&
                                                                        //   (lineDetail.isCustomRow ==
                                                                        //     undefined ||
                                                                        //     !lineDetail.isCustomRow) &&
                                                                        //   headerLblIdx +
                                                                        //     1 ==
                                                                        //     headerLblArray.length &&
                                                                        //   "initial",
                                                                      }
                                                                    }
                                                                  >
                                                                    <InputNumber
                                                                      // style={{
                                                                      //   border:
                                                                      //     "1px solid black",
                                                                      // }}
                                                                      id="InputNumber1"
                                                                      value={
                                                                        lineDetail[
                                                                          "column" +
                                                                            columnNo
                                                                        ] === ""
                                                                          ? null
                                                                          : typeof lineDetail[
                                                                                "column" +
                                                                                  columnNo
                                                                              ] ===
                                                                              "number"
                                                                            ? Math.round(
                                                                                lineDetail[
                                                                                  "column" +
                                                                                    columnNo
                                                                                ]
                                                                              )
                                                                            : undefined
                                                                      }
                                                                      onBlur={(
                                                                        e
                                                                      ) =>
                                                                        this.amountOnBlur(
                                                                          e,
                                                                          heading,
                                                                          lineDetail,
                                                                          headerLblIdx,
                                                                          columnNo
                                                                        )
                                                                      }
                                                                      useGrouping={
                                                                        true
                                                                      }
                                                                      disabled={
                                                                        linkSharedUser ==
                                                                          3 ||
                                                                        lineDetail.column1 ===
                                                                          ""
                                                                      }
                                                                      locale="sv-SE"
                                                                    />

                                                                    {/* {headerLblIdx +
                                                              "==" +
                                                              headerLblArray.length} */}

                                                                    {headerLblArray.length ==
                                                                      headerLblIdx +
                                                                        1 &&
                                                                      !lineDetail.isCustomRow &&
                                                                      linkSharedUser !=
                                                                        3 &&
                                                                      lineDetail.dataType !=
                                                                        "Static" && (
                                                                        <i
                                                                          id="MgmtStmtAddNewLineIcon1"
                                                                          className="fa fa-plus"
                                                                          aria-hidden="true"
                                                                          onClick={(
                                                                            e
                                                                          ) =>
                                                                            this.onClickAddNewRow(
                                                                              lineDetail,
                                                                              heading
                                                                            )
                                                                          }
                                                                          title="Add New Line 1"
                                                                          style={{
                                                                            display:
                                                                              linkSharedUser ==
                                                                                3 &&
                                                                              "none"
                                                                          }}
                                                                        ></i>
                                                                      )}

                                                                    {lineDetail.isCustomRow &&
                                                                      headerLblArray.length ==
                                                                        headerLblIdx +
                                                                          1 && (
                                                                        <i
                                                                          id={
                                                                            sideBarStatus
                                                                              ? "mgmtCustomRowDeleteOpenSideBar"
                                                                              : "mgmtCustomRowDeleteCloseSideBar"
                                                                          }
                                                                          title="1"
                                                                          className="pi pi-trash"
                                                                          style={{
                                                                            display:
                                                                              linkSharedUser ==
                                                                                3 &&
                                                                              "none"
                                                                          }}
                                                                          onClick={this.deleteCustomRow.bind(
                                                                            this,
                                                                            lineDetail,
                                                                            heading
                                                                          )}
                                                                        />
                                                                      )}
                                                                  </Col>
                                                                );
                                                              } else {
                                                                if (
                                                                  lineDetail.isLineSum
                                                                ) {
                                                                  return (
                                                                    <Col
                                                                      xs={2}
                                                                      sm={2}
                                                                      md={2}
                                                                      lg={2}
                                                                      xl={2}
                                                                      style={{
                                                                        width:
                                                                          "15%"
                                                                      }}
                                                                    >
                                                                      <InputNumber
                                                                        inputId="integeronly"
                                                                        className="mgmtColWiseAmountBoxDisabled"
                                                                        value={Math.round(
                                                                          lineDetail[
                                                                            "column" +
                                                                              columnNo
                                                                          ]
                                                                        )}
                                                                        disabled
                                                                        locale="sv-SE"
                                                                      />
                                                                    </Col>
                                                                  );
                                                                }
                                                              }
                                                            }
                                                          )}

                                                          {headerLblArray.length ==
                                                            0 && (
                                                            <Col
                                                              xs={2}
                                                              sm={2}
                                                              md={2}
                                                              lg={2}
                                                              xl={2}
                                                              style={{
                                                                width: "12%"
                                                              }}
                                                            >
                                                              {lineDetail.isLineSum ? (
                                                                <InputNumber
                                                                  inputId="integeronly"
                                                                  className="mgmtAmountBoxDisabled"
                                                                  value={Math.round(
                                                                    lineDetail.column2
                                                                  )}
                                                                  disabled
                                                                  locale="sv-SE"
                                                                />
                                                              ) : lineDetail.dataType ==
                                                                "Static" ? (
                                                                <div></div>
                                                              ) : (
                                                                !lineDetail.isHeader && (
                                                                  <div>
                                                                    <InputNumber
                                                                      // style={{
                                                                      //   border:
                                                                      //     "1px solid black",
                                                                      // }}
                                                                      className="mgmtAmountBox"
                                                                      id="InputNumber2"
                                                                      // value={
                                                                      //   lineDetail.column2 !=
                                                                      //   undefined
                                                                      //     ? Math.round(
                                                                      //         lineDetail.column2
                                                                      //       )
                                                                      //     : undefined
                                                                      // }
                                                                      value={
                                                                        lineDetail.column2 ===
                                                                        ""
                                                                          ? null
                                                                          : typeof lineDetail.column2 ===
                                                                              "number"
                                                                            ? Math.round(
                                                                                lineDetail.column2
                                                                              )
                                                                            : undefined
                                                                      }
                                                                      onBlur={(
                                                                        e
                                                                      ) =>
                                                                        this.amountOnBlur(
                                                                          e,
                                                                          heading,
                                                                          lineDetail,
                                                                          0,
                                                                          0
                                                                        )
                                                                      }
                                                                      useGrouping={
                                                                        true
                                                                      }
                                                                      disabled={
                                                                        linkSharedUser ==
                                                                          3 ||
                                                                        lineDetail.column1 ==
                                                                          ""
                                                                      }
                                                                      locale="sv-SE"
                                                                    />

                                                                    {!lineDetail.isCustomRow &&
                                                                      linkSharedUser !=
                                                                        3 && (
                                                                        <i
                                                                          id="MgmtStmtAddNewLineIcon"
                                                                          className="fa fa-plus"
                                                                          aria-hidden="true"
                                                                          onClick={(
                                                                            e
                                                                          ) =>
                                                                            this.addNewLine(
                                                                              lineDetail,
                                                                              heading,
                                                                              lineDetailIdx
                                                                            )
                                                                          }
                                                                          title="Add New Line 55"
                                                                          style={{
                                                                            display:
                                                                              linkSharedUser ==
                                                                                3 &&
                                                                              "none"
                                                                          }}
                                                                        ></i>
                                                                      )}

                                                                    {lineDetail.isCustomRow && (
                                                                      <i
                                                                        // id={
                                                                        //   sideBarStatus
                                                                        //     ? "mgmtCustomRowDeleteOpenSideBar"
                                                                        //     : "mgmtCustomRowDeleteCloseSideBar"
                                                                        // }
                                                                        id="MgmtStmtDeleteIcon2"
                                                                        className="pi pi-trash"
                                                                        title="2"
                                                                        style={{
                                                                          display:
                                                                            linkSharedUser ==
                                                                              3 &&
                                                                            "none"
                                                                        }}
                                                                        onClick={this.deleteCustomRow.bind(
                                                                          this,
                                                                          lineDetail,
                                                                          heading
                                                                        )}
                                                                      />
                                                                      // <i
                                                                      //   id="MgmtStmtAddNewLineIcon"
                                                                      //   className="fa fa-plus"
                                                                      //   aria-hidden="true"
                                                                      //   onClick={(
                                                                      //     e
                                                                      //   ) =>
                                                                      //     this.addNewLine(
                                                                      //       lineDetail,
                                                                      //       heading,
                                                                      //       lineDetailIdx
                                                                      //     )
                                                                      //   }
                                                                      //   title="Add New Line 55"
                                                                      //   style={{
                                                                      //     display:
                                                                      //       linkSharedUser ==
                                                                      //         3 &&
                                                                      //       "none",
                                                                      //   }}
                                                                      // ></i>
                                                                    )}
                                                                  </div>
                                                                )
                                                              )}
                                                            </Col>
                                                          )}
                                                        </Row>
                                                      )
                                                    ) : (
                                                      <div className="mgmtEditor">
                                                        <Editor
                                                          id="comments"
                                                          className="mgmtEditorComponent"
                                                          ref={
                                                            lineDetail.templateColumn2 ==
                                                              "IXBRLTagOpen" &&
                                                            this.textAreaRef
                                                          }
                                                          placeholder={
                                                            lineDetail.placeHolder ==
                                                              "" &&
                                                            lineDetail.dataType ==
                                                              "Textarea"
                                                              ? "Comments"
                                                              : lineDetail.isVisible ==
                                                                  false && ""
                                                          }
                                                          disabled={
                                                            linkSharedUser == 3
                                                          }
                                                          value={
                                                            lineDetail.isVisible ==
                                                              false && ""
                                                              ? ""
                                                              : lineDetail.name
                                                          }
                                                          // className="mgmtTxtArea"
                                                          onChange={(e) =>
                                                            this.txtAreaOnChange(
                                                              e,
                                                              heading,
                                                              lineDetail
                                                            )
                                                          }
                                                          onBlur={(e) =>
                                                            this.txtAreaOnBlur(
                                                              e,
                                                              heading,
                                                              lineDetail,
                                                              true
                                                            )
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </div>
                                                </Col>
                                              </Row>
                                            </>
                                          );
                                        }
                                      )
                                    : this.renderMatrixColumn(
                                        heading,
                                        lineDetailsArray
                                      )}
                                </AccordionTab>
                              );
                            }
                          }
                        )}
                      </Accordion>
                    )}
                  </Col>
                  <center className="MgmtSaveBtnCenter">
                    <Button
                      label={TranslationFile.previousBtn[userSelectedLanguage]}
                      aria-label={
                        TranslationFile.FooterAnnualReport[userSelectedLanguage]
                      }
                      onClick={() => this.pageNavigation("notes")}
                      id="annualReportBtn"
                      className="MgmtSaveBtn"
                    />
                    <Button
                      label={TranslationFile.nextBtn[userSelectedLanguage]}
                      aria-label={
                        TranslationFile.FooterAnnualReport[userSelectedLanguage]
                      }
                      onClick={() => this.pageNavigation("representative")}
                      id="annualReportBtn"
                      className="MgmtSaveBtn"
                    />
                  </center>
                </Row>
              )}
            </div>
            <ScrolltoTop />
            <Footer_contact_tab
              sideBar={this.state.sideBarStatus}
              isCorpPortal={false}
              isHomePage={true}
            />
            <Dialog
              visible={pdfLoading}
              style={{ width: "30vw" }}
              className="pdfDialogBox"
              blockScroll
              closable={false}
            >
              <div className="pdfLoading">
                <i
                  className="pi pi-spin pi-spinner"
                  style={{ fontSize: "2rem" }}
                ></i>
              </div>
            </Dialog>
          </>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps, null)(ManagementStatement);
